export const patternClassMap = new Map([
  ["苦_酸甘_塩_旨塩_苦塩_旨_旨_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_旨_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_旨_甘", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_旨_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_旨_塩", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_酸甘_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_酸甘_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_酸甘_甘", "C_3"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_酸甘_酸", "S_3"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_酸甘_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_苦_苦塩", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_苦_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_苦_甘", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_苦_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_苦_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_酸_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_酸_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_酸_甘", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_酸_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_酸_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_甘_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_甘_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_甘_甘", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_甘_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_旨_甘_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_旨_苦塩", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_旨_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_旨_甘", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_旨_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_旨_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_酸甘_苦塩", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_酸甘_旨", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_酸甘_甘", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_酸甘_酸", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_酸甘_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_苦_苦塩", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_苦_旨", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_苦_甘", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_苦_酸", "N_3"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_苦_塩", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_酸_苦塩", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_酸_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_酸_甘", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_酸_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_酸_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_甘_苦塩", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_甘_旨", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_甘_甘", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_甘_酸", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_苦_甘_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_旨_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_旨_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_旨_甘", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_旨_酸", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_旨_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_酸甘_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_酸甘_旨", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_酸甘_甘", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_酸甘_酸", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_酸甘_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_苦_苦塩", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_苦_旨", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_苦_甘", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_苦_酸", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_苦_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_酸_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_酸_旨", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_酸_甘", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_酸_酸", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_酸_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_甘_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_甘_旨", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_甘_甘", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_甘_酸", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_塩_甘_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_旨_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_旨_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_旨_甘", "C_3"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_旨_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_旨_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_酸甘_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_酸甘_旨", "C_3"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_酸甘_甘", "C_3"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_酸甘_酸", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_酸甘_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_苦_苦塩", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_苦_旨", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_苦_甘", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_苦_酸", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_苦_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_酸_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_酸_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_酸_甘", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_酸_酸", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_酸_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_甘_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_甘_旨", "C_3"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_甘_甘", "C_3"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_甘_酸", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_甘_甘_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_旨_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_旨_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_旨_甘", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_旨_酸", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_旨_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_酸甘_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_酸甘_旨", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_酸甘_甘", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_酸甘_酸", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_酸甘_塩", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_苦_苦塩", "N_2"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_苦_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_苦_甘", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_苦_酸", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_苦_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_酸_苦塩", "N_4"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_酸_旨", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_酸_甘", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_酸_酸", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_酸_塩", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_甘_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_甘_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_甘_甘", "B_2"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_甘_酸", "S_1"],
  ["苦_酸甘_塩_旨塩_苦塩_酸_甘_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_旨_旨_旨_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_旨_旨", "U_4"],
  ["苦_酸甘_塩_旨塩_旨_旨_旨_甘", "A_3"],
  ["苦_酸甘_塩_旨塩_旨_旨_旨_酸", "U_4"],
  ["苦_酸甘_塩_旨塩_旨_旨_旨_塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_酸甘_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_酸甘_旨", "U_2"],
  ["苦_酸甘_塩_旨塩_旨_旨_酸甘_甘", "A_3"],
  ["苦_酸甘_塩_旨塩_旨_旨_酸甘_酸", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_酸甘_塩", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_苦_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_苦_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_苦_甘", "U_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_苦_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_苦_塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_酸_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_酸_旨", "U_4"],
  ["苦_酸甘_塩_旨塩_旨_旨_酸_甘", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_酸_酸", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_酸_塩", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_甘_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_甘_旨", "A_3"],
  ["苦_酸甘_塩_旨塩_旨_旨_甘_甘", "A_3"],
  ["苦_酸甘_塩_旨塩_旨_旨_甘_酸", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_旨_甘_塩", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_旨_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_旨_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_旨_甘", "U_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_旨_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_旨_塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_酸甘_苦塩", "N_3"],
  ["苦_酸甘_塩_旨塩_旨_苦_酸甘_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_酸甘_甘", "C_2"],
  ["苦_酸甘_塩_旨塩_旨_苦_酸甘_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_酸甘_塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_苦_苦塩", "N_2"],
  ["苦_酸甘_塩_旨塩_旨_苦_苦_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_苦_甘", "N_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_苦_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_苦_塩", "N_2"],
  ["苦_酸甘_塩_旨塩_旨_苦_酸_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_酸_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_酸_甘", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_酸_酸", "U_3"],
  ["苦_酸甘_塩_旨塩_旨_苦_酸_塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_甘_苦塩", "N_2"],
  ["苦_酸甘_塩_旨塩_旨_苦_甘_旨", "U_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_甘_甘", "C_2"],
  ["苦_酸甘_塩_旨塩_旨_苦_甘_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_苦_甘_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_旨_塩_旨_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_旨_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_旨_甘", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_旨_酸", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_旨_塩", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_酸甘_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_旨_塩_酸甘_旨", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_酸甘_甘", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_酸甘_酸", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_酸甘_塩", "S_3"],
  ["苦_酸甘_塩_旨塩_旨_塩_苦_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_旨_塩_苦_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_苦_甘", "N_5"],
  ["苦_酸甘_塩_旨塩_旨_塩_苦_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_苦_塩", "N_5"],
  ["苦_酸甘_塩_旨塩_旨_塩_酸_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_旨_塩_酸_旨", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_酸_甘", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_酸_酸", "S_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_酸_塩", "S_3"],
  ["苦_酸甘_塩_旨塩_旨_塩_甘_苦塩", "N_5"],
  ["苦_酸甘_塩_旨塩_旨_塩_甘_旨", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_甘_甘", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_甘_酸", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_塩_甘_塩", "S_3"],
  ["苦_酸甘_塩_旨塩_旨_甘_旨_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_旨_旨", "A_3"],
  ["苦_酸甘_塩_旨塩_旨_甘_旨_甘", "A_3"],
  ["苦_酸甘_塩_旨塩_旨_甘_旨_酸", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_旨_塩", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_酸甘_苦塩", "C_3"],
  ["苦_酸甘_塩_旨塩_旨_甘_酸甘_旨", "A_3"],
  ["苦_酸甘_塩_旨塩_旨_甘_酸甘_甘", "A_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_酸甘_酸", "U_3"],
  ["苦_酸甘_塩_旨塩_旨_甘_酸甘_塩", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_苦_苦塩", "N_2"],
  ["苦_酸甘_塩_旨塩_旨_甘_苦_旨", "U_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_苦_甘", "C_2"],
  ["苦_酸甘_塩_旨塩_旨_甘_苦_酸", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_苦_塩", "C_3"],
  ["苦_酸甘_塩_旨塩_旨_甘_酸_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_酸_旨", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_酸_甘", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_酸_酸", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_酸_塩", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_甘_苦塩", "C_3"],
  ["苦_酸甘_塩_旨塩_旨_甘_甘_旨", "A_3"],
  ["苦_酸甘_塩_旨塩_旨_甘_甘_甘", "A_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_甘_酸", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_甘_甘_塩", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_旨_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_旨_旨", "U_4"],
  ["苦_酸甘_塩_旨塩_旨_酸_旨_甘", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_旨_酸", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_旨_塩", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_酸甘_苦塩", "S_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_酸甘_旨", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_酸甘_甘", "U_3"],
  ["苦_酸甘_塩_旨塩_旨_酸_酸甘_酸", "U_3"],
  ["苦_酸甘_塩_旨塩_旨_酸_酸甘_塩", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_苦_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_苦_旨", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_苦_甘", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_苦_酸", "U_3"],
  ["苦_酸甘_塩_旨塩_旨_酸_苦_塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_酸_苦塩", "S_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_酸_旨", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_酸_甘", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_酸_酸", "S_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_酸_塩", "S_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_甘_苦塩", "B_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_甘_旨", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_甘_甘", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_甘_酸", "C_1"],
  ["苦_酸甘_塩_旨塩_旨_酸_甘_塩", "C_1"],
  ["苦_酸甘_塩_甘_苦塩_旨_旨_苦塩", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_旨_旨_旨", "A_4"],
  ["苦_酸甘_塩_甘_苦塩_旨_旨_甘", "C_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_旨_酸", "B_1"],
  ["苦_酸甘_塩_甘_苦塩_旨_旨_塩", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_旨_酸甘_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_酸甘_旨", "C_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_酸甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_苦塩_旨_酸甘_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_酸甘_塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_苦_苦塩", "N_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_苦_旨", "N_1"],
  ["苦_酸甘_塩_甘_苦塩_旨_苦_甘", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_苦_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_苦_塩", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_旨_酸_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_酸_旨", "B_1"],
  ["苦_酸甘_塩_甘_苦塩_旨_酸_甘", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_酸_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_酸_塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_甘_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_甘_旨", "C_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_苦塩_旨_甘_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_旨_甘_塩", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_苦_旨_苦塩", "N_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_旨_旨", "N_1"],
  ["苦_酸甘_塩_甘_苦塩_苦_旨_甘", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_旨_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_旨_塩", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_苦_酸甘_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_酸甘_旨", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_酸甘_甘", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_酸甘_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_酸甘_塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_苦_苦塩", "N_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_苦_旨", "N_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_苦_甘", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_苦_酸", "N_3"],
  ["苦_酸甘_塩_甘_苦塩_苦_苦_塩", "N_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_酸_苦塩", "N_3"],
  ["苦_酸甘_塩_甘_苦塩_苦_酸_旨", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_酸_甘", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_酸_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_酸_塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_甘_苦塩", "N_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_甘_旨", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_甘_甘", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_甘_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_苦_甘_塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_塩_旨_苦塩", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_塩_旨_旨", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_塩_旨_甘", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_塩_旨_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_塩_旨_塩", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_塩_酸甘_苦塩", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_塩_酸甘_旨", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_塩_酸甘_甘", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_塩_酸甘_酸", "S_2"],
  ["苦_酸甘_塩_甘_苦塩_塩_酸甘_塩", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_塩_苦_苦塩", "N_2"],
  ["苦_酸甘_塩_甘_苦塩_塩_苦_旨", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_塩_苦_甘", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_塩_苦_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_塩_苦_塩", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_塩_酸_苦塩", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_塩_酸_旨", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_塩_酸_甘", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_塩_酸_酸", "S_1"],
  ["苦_酸甘_塩_甘_苦塩_塩_酸_塩", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_塩_甘_苦塩", "N_5"],
  ["苦_酸甘_塩_甘_苦塩_塩_甘_旨", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_塩_甘_甘", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_塩_甘_酸", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_塩_甘_塩", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_甘_旨_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_甘_旨_旨", "C_2"],
  ["苦_酸甘_塩_甘_苦塩_甘_旨_甘", "A_1"],
  ["苦_酸甘_塩_甘_苦塩_甘_旨_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_甘_旨_塩", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_甘_酸甘_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_甘_酸甘_旨", "A_1"],
  ["苦_酸甘_塩_甘_苦塩_甘_酸甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_苦塩_甘_酸甘_酸", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_甘_酸甘_塩", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_甘_苦_苦塩", "N_2"],
  ["苦_酸甘_塩_甘_苦塩_甘_苦_旨", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_甘_苦_甘", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_甘_苦_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_甘_苦_塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_甘_酸_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_甘_酸_旨", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_甘_酸_甘", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_甘_酸_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_甘_酸_塩", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_甘_甘_苦塩", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_甘_甘_旨", "A_1"],
  ["苦_酸甘_塩_甘_苦塩_甘_甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_苦塩_甘_甘_酸", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_甘_甘_塩", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_酸_旨_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_旨_旨", "B_1"],
  ["苦_酸甘_塩_甘_苦塩_酸_旨_甘", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_旨_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_旨_塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_酸甘_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_酸甘_旨", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_酸甘_甘", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_酸_酸甘_酸", "S_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_酸甘_塩", "S_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_苦_苦塩", "N_3"],
  ["苦_酸甘_塩_甘_苦塩_酸_苦_旨", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_苦_甘", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_苦_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_苦_塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_酸_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_酸_旨", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_酸_甘", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_酸_酸", "S_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_酸_塩", "S_1"],
  ["苦_酸甘_塩_甘_苦塩_酸_甘_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_甘_旨", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_甘_甘", "C_3"],
  ["苦_酸甘_塩_甘_苦塩_酸_甘_酸", "B_2"],
  ["苦_酸甘_塩_甘_苦塩_酸_甘_塩", "C_3"],
  ["苦_酸甘_塩_甘_旨_旨_旨_苦塩", "U_1"],
  ["苦_酸甘_塩_甘_旨_旨_旨_旨", "U_2"],
  ["苦_酸甘_塩_甘_旨_旨_旨_甘", "A_3"],
  ["苦_酸甘_塩_甘_旨_旨_旨_酸", "U_2"],
  ["苦_酸甘_塩_甘_旨_旨_旨_塩", "A_3"],
  ["苦_酸甘_塩_甘_旨_旨_酸甘_苦塩", "C_2"],
  ["苦_酸甘_塩_甘_旨_旨_酸甘_旨", "A_3"],
  ["苦_酸甘_塩_甘_旨_旨_酸甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_旨_酸甘_酸", "U_3"],
  ["苦_酸甘_塩_甘_旨_旨_酸甘_塩", "C_1"],
  ["苦_酸甘_塩_甘_旨_旨_苦_苦塩", "N_1"],
  ["苦_酸甘_塩_甘_旨_旨_苦_旨", "A_2"],
  ["苦_酸甘_塩_甘_旨_旨_苦_甘", "A_2"],
  ["苦_酸甘_塩_甘_旨_旨_苦_酸", "A_2"],
  ["苦_酸甘_塩_甘_旨_旨_苦_塩", "A_2"],
  ["苦_酸甘_塩_甘_旨_旨_酸_苦塩", "B_1"],
  ["苦_酸甘_塩_甘_旨_旨_酸_旨", "U_2"],
  ["苦_酸甘_塩_甘_旨_旨_酸_甘", "U_3"],
  ["苦_酸甘_塩_甘_旨_旨_酸_酸", "U_3"],
  ["苦_酸甘_塩_甘_旨_旨_酸_塩", "C_1"],
  ["苦_酸甘_塩_甘_旨_旨_甘_苦塩", "A_1"],
  ["苦_酸甘_塩_甘_旨_旨_甘_旨", "A_3"],
  ["苦_酸甘_塩_甘_旨_旨_甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_旨_甘_酸", "U_3"],
  ["苦_酸甘_塩_甘_旨_旨_甘_塩", "A_3"],
  ["苦_酸甘_塩_甘_旨_苦_旨_苦塩", "N_2"],
  ["苦_酸甘_塩_甘_旨_苦_旨_旨", "A_2"],
  ["苦_酸甘_塩_甘_旨_苦_旨_甘", "A_2"],
  ["苦_酸甘_塩_甘_旨_苦_旨_酸", "A_2"],
  ["苦_酸甘_塩_甘_旨_苦_旨_塩", "A_2"],
  ["苦_酸甘_塩_甘_旨_苦_酸甘_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_苦_酸甘_旨", "A_2"],
  ["苦_酸甘_塩_甘_旨_苦_酸甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_苦_酸甘_酸", "B_2"],
  ["苦_酸甘_塩_甘_旨_苦_酸甘_塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_苦_苦_苦塩", "N_2"],
  ["苦_酸甘_塩_甘_旨_苦_苦_旨", "A_2"],
  ["苦_酸甘_塩_甘_旨_苦_苦_甘", "A_2"],
  ["苦_酸甘_塩_甘_旨_苦_苦_酸", "B_2"],
  ["苦_酸甘_塩_甘_旨_苦_苦_塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_苦_酸_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_苦_酸_旨", "A_2"],
  ["苦_酸甘_塩_甘_旨_苦_酸_甘", "A_2"],
  ["苦_酸甘_塩_甘_旨_苦_酸_酸", "B_2"],
  ["苦_酸甘_塩_甘_旨_苦_酸_塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_苦_甘_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_苦_甘_旨", "A_2"],
  ["苦_酸甘_塩_甘_旨_苦_甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_苦_甘_酸", "A_2"],
  ["苦_酸甘_塩_甘_旨_苦_甘_塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_塩_旨_苦塩", "N_5"],
  ["苦_酸甘_塩_甘_旨_塩_旨_旨", "A_3"],
  ["苦_酸甘_塩_甘_旨_塩_旨_甘", "A_3"],
  ["苦_酸甘_塩_甘_旨_塩_旨_酸", "C_1"],
  ["苦_酸甘_塩_甘_旨_塩_旨_塩", "C_1"],
  ["苦_酸甘_塩_甘_旨_塩_酸甘_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_塩_酸甘_旨", "C_1"],
  ["苦_酸甘_塩_甘_旨_塩_酸甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_塩_酸甘_酸", "U_3"],
  ["苦_酸甘_塩_甘_旨_塩_酸甘_塩", "C_3"],
  ["苦_酸甘_塩_甘_旨_塩_苦_苦塩", "N_5"],
  ["苦_酸甘_塩_甘_旨_塩_苦_旨", "A_2"],
  ["苦_酸甘_塩_甘_旨_塩_苦_甘", "B_2"],
  ["苦_酸甘_塩_甘_旨_塩_苦_酸", "B_2"],
  ["苦_酸甘_塩_甘_旨_塩_苦_塩", "N_5"],
  ["苦_酸甘_塩_甘_旨_塩_酸_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_塩_酸_旨", "C_1"],
  ["苦_酸甘_塩_甘_旨_塩_酸_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_塩_酸_酸", "S_2"],
  ["苦_酸甘_塩_甘_旨_塩_酸_塩", "S_3"],
  ["苦_酸甘_塩_甘_旨_塩_甘_苦塩", "C_3"],
  ["苦_酸甘_塩_甘_旨_塩_甘_旨", "A_3"],
  ["苦_酸甘_塩_甘_旨_塩_甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_塩_甘_酸", "A_1"],
  ["苦_酸甘_塩_甘_旨_塩_甘_塩", "C_3"],
  ["苦_酸甘_塩_甘_旨_甘_旨_苦塩", "C_2"],
  ["苦_酸甘_塩_甘_旨_甘_旨_旨", "A_3"],
  ["苦_酸甘_塩_甘_旨_甘_旨_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_旨_酸", "U_3"],
  ["苦_酸甘_塩_甘_旨_甘_旨_塩", "A_3"],
  ["苦_酸甘_塩_甘_旨_甘_酸甘_苦塩", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_酸甘_旨", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_酸甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_酸甘_酸", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_酸甘_塩", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_苦_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_甘_苦_旨", "A_2"],
  ["苦_酸甘_塩_甘_旨_甘_苦_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_苦_酸", "A_2"],
  ["苦_酸甘_塩_甘_旨_甘_苦_塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_甘_酸_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_甘_酸_旨", "U_3"],
  ["苦_酸甘_塩_甘_旨_甘_酸_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_酸_酸", "U_3"],
  ["苦_酸甘_塩_甘_旨_甘_酸_塩", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_甘_苦塩", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_甘_旨", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_甘_酸", "A_1"],
  ["苦_酸甘_塩_甘_旨_甘_甘_塩", "A_1"],
  ["苦_酸甘_塩_甘_旨_酸_旨_苦塩", "B_1"],
  ["苦_酸甘_塩_甘_旨_酸_旨_旨", "U_2"],
  ["苦_酸甘_塩_甘_旨_酸_旨_甘", "U_3"],
  ["苦_酸甘_塩_甘_旨_酸_旨_酸", "U_3"],
  ["苦_酸甘_塩_甘_旨_酸_旨_塩", "C_1"],
  ["苦_酸甘_塩_甘_旨_酸_酸甘_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_酸_酸甘_旨", "U_3"],
  ["苦_酸甘_塩_甘_旨_酸_酸甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_酸_酸甘_酸", "U_3"],
  ["苦_酸甘_塩_甘_旨_酸_酸甘_塩", "U_3"],
  ["苦_酸甘_塩_甘_旨_酸_苦_苦塩", "A_2"],
  ["苦_酸甘_塩_甘_旨_酸_苦_旨", "A_2"],
  ["苦_酸甘_塩_甘_旨_酸_苦_甘", "A_2"],
  ["苦_酸甘_塩_甘_旨_酸_苦_酸", "B_2"],
  ["苦_酸甘_塩_甘_旨_酸_苦_塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_酸_酸_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_酸_酸_旨", "U_3"],
  ["苦_酸甘_塩_甘_旨_酸_酸_甘", "U_3"],
  ["苦_酸甘_塩_甘_旨_酸_酸_酸", "U_3"],
  ["苦_酸甘_塩_甘_旨_酸_酸_塩", "S_2"],
  ["苦_酸甘_塩_甘_旨_酸_甘_苦塩", "B_2"],
  ["苦_酸甘_塩_甘_旨_酸_甘_旨", "U_3"],
  ["苦_酸甘_塩_甘_旨_酸_甘_甘", "A_1"],
  ["苦_酸甘_塩_甘_旨_酸_甘_酸", "U_3"],
  ["苦_酸甘_塩_甘_旨_酸_甘_塩", "A_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_旨_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_旨_旨", "U_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_旨_甘", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_旨_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_旨_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_酸甘_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_酸甘_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_酸甘_甘", "A_3"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_酸甘_酸", "U_3"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_酸甘_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_苦_苦塩", "N_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_苦_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_苦_甘", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_苦_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_苦_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_酸_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_酸_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_酸_甘", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_酸_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_酸_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_甘_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_甘_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_甘_甘", "A_3"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_甘_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_旨_甘_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_旨_苦塩", "N_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_旨_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_旨_甘", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_旨_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_旨_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_酸甘_苦塩", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_酸甘_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_酸甘_甘", "A_2"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_酸甘_酸", "B_2"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_酸甘_塩", "N_3"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_苦_苦塩", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_苦_旨", "N_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_苦_甘", "N_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_苦_酸", "N_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_苦_塩", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_酸_苦塩", "N_3"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_酸_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_酸_甘", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_酸_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_酸_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_甘_苦塩", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_甘_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_甘_甘", "A_2"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_甘_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_苦_甘_塩", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_旨_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_旨_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_旨_甘", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_旨_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_旨_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_酸甘_苦塩", "N_5"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_酸甘_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_酸甘_甘", "C_3"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_酸甘_酸", "S_2"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_酸甘_塩", "N_5"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_苦_苦塩", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_苦_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_苦_甘", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_苦_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_苦_塩", "N_5"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_酸_苦塩", "N_5"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_酸_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_酸_甘", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_酸_酸", "S_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_酸_塩", "N_5"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_甘_苦塩", "N_5"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_甘_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_甘_甘", "C_3"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_甘_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_塩_甘_塩", "N_5"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_旨_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_旨_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_旨_甘", "A_3"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_旨_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_旨_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_酸甘_苦塩", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_酸甘_旨", "A_3"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_酸甘_甘", "A_1"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_酸甘_酸", "U_3"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_酸甘_塩", "C_3"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_苦_苦塩", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_苦_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_苦_甘", "A_2"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_苦_酸", "N_3"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_苦_塩", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_酸_苦塩", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_酸_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_酸_甘", "C_2"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_酸_酸", "U_3"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_酸_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_甘_苦塩", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_甘_旨", "A_3"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_甘_甘", "A_1"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_甘_酸", "C_2"],
  ["苦_酸甘_旨_旨塩_苦塩_甘_甘_塩", "C_3"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_旨_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_旨_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_旨_甘", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_旨_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_旨_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_酸甘_苦塩", "B_2"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_酸甘_旨", "U_4"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_酸甘_甘", "U_3"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_酸甘_酸", "U_3"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_酸甘_塩", "S_2"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_苦_苦塩", "N_3"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_苦_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_苦_甘", "N_3"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_苦_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_苦_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_酸_苦塩", "N_4"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_酸_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_酸_甘", "U_3"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_酸_酸", "S_1"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_酸_塩", "S_1"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_甘_苦塩", "N_2"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_甘_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_甘_甘", "C_2"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_甘_酸", "U_3"],
  ["苦_酸甘_旨_旨塩_苦塩_酸_甘_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_旨_旨_苦塩", "U_1"],
  ["苦_酸甘_旨_旨塩_旨_旨_旨_旨", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_旨_旨_甘", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_旨_旨_酸", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_旨_旨_塩", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_旨_酸甘_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_旨_酸甘_旨", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_旨_酸甘_甘", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_旨_酸甘_酸", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_旨_酸甘_塩", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_旨_苦_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_旨_苦_旨", "U_1"],
  ["苦_酸甘_旨_旨塩_旨_旨_苦_甘", "U_1"],
  ["苦_酸甘_旨_旨塩_旨_旨_苦_酸", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_旨_苦_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_旨_酸_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_旨_酸_旨", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_旨_酸_甘", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_旨_酸_酸", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_旨_酸_塩", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_旨_甘_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_旨_甘_旨", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_旨_甘_甘", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_旨_甘_酸", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_旨_甘_塩", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_苦_旨_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_旨_旨", "U_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_旨_甘", "U_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_旨_酸", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_苦_旨_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_酸甘_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_酸甘_旨", "U_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_酸甘_甘", "A_2"],
  ["苦_酸甘_旨_旨塩_旨_苦_酸甘_酸", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_苦_酸甘_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_苦_苦塩", "N_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_苦_旨", "U_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_苦_甘", "A_2"],
  ["苦_酸甘_旨_旨塩_旨_苦_苦_酸", "B_3"],
  ["苦_酸甘_旨_旨塩_旨_苦_苦_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_酸_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_酸_旨", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_苦_酸_甘", "A_2"],
  ["苦_酸甘_旨_旨塩_旨_苦_酸_酸", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_苦_酸_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_甘_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_甘_旨", "U_1"],
  ["苦_酸甘_旨_旨塩_旨_苦_甘_甘", "A_2"],
  ["苦_酸甘_旨_旨塩_旨_苦_甘_酸", "A_2"],
  ["苦_酸甘_旨_旨塩_旨_苦_甘_塩", "U_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_旨_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_旨_旨", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_塩_旨_甘", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_塩_旨_酸", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_塩_旨_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_酸甘_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_酸甘_旨", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_塩_酸甘_甘", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_塩_酸甘_酸", "C_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_酸甘_塩", "C_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_苦_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_苦_旨", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_苦_甘", "U_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_苦_酸", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_苦_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_酸_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_酸_旨", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_塩_酸_甘", "C_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_酸_酸", "C_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_酸_塩", "C_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_甘_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_甘_旨", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_塩_甘_甘", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_塩_甘_酸", "C_1"],
  ["苦_酸甘_旨_旨塩_旨_塩_甘_塩", "C_1"],
  ["苦_酸甘_旨_旨塩_旨_甘_旨_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_甘_旨_旨", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_甘_旨_甘", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_甘_旨_酸", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_甘_旨_塩", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_甘_酸甘_苦塩", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_甘_酸甘_旨", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_甘_酸甘_甘", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_甘_酸甘_酸", "U_3"],
  ["苦_酸甘_旨_旨塩_旨_甘_酸甘_塩", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_甘_苦_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_甘_苦_旨", "U_1"],
  ["苦_酸甘_旨_旨塩_旨_甘_苦_甘", "A_2"],
  ["苦_酸甘_旨_旨塩_旨_甘_苦_酸", "A_2"],
  ["苦_酸甘_旨_旨塩_旨_甘_苦_塩", "U_1"],
  ["苦_酸甘_旨_旨塩_旨_甘_酸_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_甘_酸_旨", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_甘_酸_甘", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_甘_酸_酸", "U_3"],
  ["苦_酸甘_旨_旨塩_旨_甘_酸_塩", "C_1"],
  ["苦_酸甘_旨_旨塩_旨_甘_甘_苦塩", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_甘_甘_旨", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_甘_甘_甘", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_甘_甘_酸", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_甘_甘_塩", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_酸_旨_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_酸_旨_旨", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_酸_旨_甘", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_酸_旨_酸", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_酸_旨_塩", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_酸_酸甘_苦塩", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_酸_酸甘_旨", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_酸_酸甘_甘", "U_3"],
  ["苦_酸甘_旨_旨塩_旨_酸_酸甘_酸", "U_3"],
  ["苦_酸甘_旨_旨塩_旨_酸_酸甘_塩", "C_1"],
  ["苦_酸甘_旨_旨塩_旨_酸_苦_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_酸_苦_旨", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_酸_苦_甘", "A_2"],
  ["苦_酸甘_旨_旨塩_旨_酸_苦_酸", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_酸_苦_塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_酸_酸_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_酸_酸_旨", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_酸_酸_甘", "U_3"],
  ["苦_酸甘_旨_旨塩_旨_酸_酸_酸", "U_4"],
  ["苦_酸甘_旨_旨塩_旨_酸_酸_塩", "C_1"],
  ["苦_酸甘_旨_旨塩_旨_酸_甘_苦塩", "B_1"],
  ["苦_酸甘_旨_旨塩_旨_酸_甘_旨", "U_2"],
  ["苦_酸甘_旨_旨塩_旨_酸_甘_甘", "A_3"],
  ["苦_酸甘_旨_旨塩_旨_酸_甘_酸", "U_3"],
  ["苦_酸甘_旨_旨塩_旨_酸_甘_塩", "C_1"],
  ["苦_酸甘_旨_甘_苦塩_旨_旨_苦塩", "B_1"],
  ["苦_酸甘_旨_甘_苦塩_旨_旨_旨", "U_1"],
  ["苦_酸甘_旨_甘_苦塩_旨_旨_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_旨_酸", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_旨_塩", "U_1"],
  ["苦_酸甘_旨_甘_苦塩_旨_酸甘_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_酸甘_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_酸甘_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_酸甘_酸", "U_3"],
  ["苦_酸甘_旨_甘_苦塩_旨_酸甘_塩", "C_3"],
  ["苦_酸甘_旨_甘_苦塩_旨_苦_苦塩", "N_1"],
  ["苦_酸甘_旨_甘_苦塩_旨_苦_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_苦_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_苦_酸", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_苦_塩", "N_1"],
  ["苦_酸甘_旨_甘_苦塩_旨_酸_苦塩", "N_3"],
  ["苦_酸甘_旨_甘_苦塩_旨_酸_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_酸_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_酸_酸", "U_3"],
  ["苦_酸甘_旨_甘_苦塩_旨_酸_塩", "B_1"],
  ["苦_酸甘_旨_甘_苦塩_旨_甘_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_甘_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_甘_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_甘_酸", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_旨_甘_塩", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_苦_旨_苦塩", "N_1"],
  ["苦_酸甘_旨_甘_苦塩_苦_旨_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_旨_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_旨_酸", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_旨_塩", "N_1"],
  ["苦_酸甘_旨_甘_苦塩_苦_酸甘_苦塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_酸甘_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_酸甘_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_酸甘_酸", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_酸甘_塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_苦_苦塩", "N_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_苦_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_苦_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_苦_酸", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_苦_塩", "N_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_酸_苦塩", "N_3"],
  ["苦_酸甘_旨_甘_苦塩_苦_酸_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_酸_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_酸_酸", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_酸_塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_甘_苦塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_甘_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_甘_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_甘_酸", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_苦_甘_塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_旨_苦塩", "N_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_旨_旨", "U_1"],
  ["苦_酸甘_旨_甘_苦塩_塩_旨_甘", "N_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_旨_酸", "B_1"],
  ["苦_酸甘_旨_甘_苦塩_塩_旨_塩", "N_5"],
  ["苦_酸甘_旨_甘_苦塩_塩_酸甘_苦塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_酸甘_旨", "C_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_酸甘_甘", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_塩_酸甘_酸", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_酸甘_塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_苦_苦塩", "N_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_苦_旨", "N_1"],
  ["苦_酸甘_旨_甘_苦塩_塩_苦_甘", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_苦_酸", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_苦_塩", "N_5"],
  ["苦_酸甘_旨_甘_苦塩_塩_酸_苦塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_酸_旨", "B_1"],
  ["苦_酸甘_旨_甘_苦塩_塩_酸_甘", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_酸_酸", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_酸_塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_甘_苦塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_甘_旨", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_塩_甘_甘", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_塩_甘_酸", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_塩_甘_塩", "C_3"],
  ["苦_酸甘_旨_甘_苦塩_甘_旨_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_旨_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_旨_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_旨_酸", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_旨_塩", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_甘_酸甘_苦塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_酸甘_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_酸甘_甘", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_甘_酸甘_酸", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_甘_酸甘_塩", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_甘_苦_苦塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_苦_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_苦_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_苦_酸", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_苦_塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_酸_苦塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_酸_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_酸_甘", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_甘_酸_酸", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_酸_塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_甘_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_甘_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_甘_甘_甘", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_甘_甘_酸", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_甘_甘_塩", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_酸_旨_苦塩", "N_3"],
  ["苦_酸甘_旨_甘_苦塩_酸_旨_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_旨_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_旨_酸", "U_3"],
  ["苦_酸甘_旨_甘_苦塩_酸_旨_塩", "B_1"],
  ["苦_酸甘_旨_甘_苦塩_酸_酸甘_苦塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_酸甘_旨", "U_3"],
  ["苦_酸甘_旨_甘_苦塩_酸_酸甘_甘", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_酸_酸甘_酸", "U_3"],
  ["苦_酸甘_旨_甘_苦塩_酸_酸甘_塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_苦_苦塩", "N_3"],
  ["苦_酸甘_旨_甘_苦塩_酸_苦_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_苦_甘", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_苦_酸", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_苦_塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_酸_苦塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_酸_旨", "U_3"],
  ["苦_酸甘_旨_甘_苦塩_酸_酸_甘", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_酸_酸", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_酸_塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_甘_苦塩", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_甘_旨", "A_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_甘_甘", "A_1"],
  ["苦_酸甘_旨_甘_苦塩_酸_甘_酸", "B_2"],
  ["苦_酸甘_旨_甘_苦塩_酸_甘_塩", "B_2"],
  ["苦_酸甘_旨_甘_旨_旨_旨_苦塩", "U_1"],
  ["苦_酸甘_旨_甘_旨_旨_旨_旨", "U_2"],
  ["苦_酸甘_旨_甘_旨_旨_旨_甘", "A_4"],
  ["苦_酸甘_旨_甘_旨_旨_旨_酸", "U_2"],
  ["苦_酸甘_旨_甘_旨_旨_旨_塩", "U_2"],
  ["苦_酸甘_旨_甘_旨_旨_酸甘_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_旨_酸甘_旨", "U_2"],
  ["苦_酸甘_旨_甘_旨_旨_酸甘_甘", "A_4"],
  ["苦_酸甘_旨_甘_旨_旨_酸甘_酸", "U_2"],
  ["苦_酸甘_旨_甘_旨_旨_酸甘_塩", "A_3"],
  ["苦_酸甘_旨_甘_旨_旨_苦_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_旨_苦_旨", "U_1"],
  ["苦_酸甘_旨_甘_旨_旨_苦_甘", "A_2"],
  ["苦_酸甘_旨_甘_旨_旨_苦_酸", "A_2"],
  ["苦_酸甘_旨_甘_旨_旨_苦_塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_旨_酸_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_旨_酸_旨", "U_2"],
  ["苦_酸甘_旨_甘_旨_旨_酸_甘", "U_2"],
  ["苦_酸甘_旨_甘_旨_旨_酸_酸", "U_2"],
  ["苦_酸甘_旨_甘_旨_旨_酸_塩", "U_2"],
  ["苦_酸甘_旨_甘_旨_旨_甘_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_旨_甘_旨", "A_4"],
  ["苦_酸甘_旨_甘_旨_旨_甘_甘", "A_4"],
  ["苦_酸甘_旨_甘_旨_旨_甘_酸", "U_2"],
  ["苦_酸甘_旨_甘_旨_旨_甘_塩", "A_3"],
  ["苦_酸甘_旨_甘_旨_苦_旨_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_旨_旨", "U_1"],
  ["苦_酸甘_旨_甘_旨_苦_旨_甘", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_旨_酸", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_旨_塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_酸甘_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_酸甘_旨", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_酸甘_甘", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_酸甘_酸", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_酸甘_塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_苦_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_苦_旨", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_苦_甘", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_苦_酸", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_苦_塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_酸_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_酸_旨", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_酸_甘", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_酸_酸", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_酸_塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_甘_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_甘_旨", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_甘_甘", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_甘_酸", "A_2"],
  ["苦_酸甘_旨_甘_旨_苦_甘_塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_塩_旨_苦塩", "U_1"],
  ["苦_酸甘_旨_甘_旨_塩_旨_旨", "U_2"],
  ["苦_酸甘_旨_甘_旨_塩_旨_甘", "A_3"],
  ["苦_酸甘_旨_甘_旨_塩_旨_酸", "U_2"],
  ["苦_酸甘_旨_甘_旨_塩_旨_塩", "A_3"],
  ["苦_酸甘_旨_甘_旨_塩_酸甘_苦塩", "C_2"],
  ["苦_酸甘_旨_甘_旨_塩_酸甘_旨", "A_3"],
  ["苦_酸甘_旨_甘_旨_塩_酸甘_甘", "A_1"],
  ["苦_酸甘_旨_甘_旨_塩_酸甘_酸", "U_3"],
  ["苦_酸甘_旨_甘_旨_塩_酸甘_塩", "C_1"],
  ["苦_酸甘_旨_甘_旨_塩_苦_苦塩", "N_1"],
  ["苦_酸甘_旨_甘_旨_塩_苦_旨", "A_2"],
  ["苦_酸甘_旨_甘_旨_塩_苦_甘", "A_2"],
  ["苦_酸甘_旨_甘_旨_塩_苦_酸", "A_2"],
  ["苦_酸甘_旨_甘_旨_塩_苦_塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_塩_酸_苦塩", "B_1"],
  ["苦_酸甘_旨_甘_旨_塩_酸_旨", "U_2"],
  ["苦_酸甘_旨_甘_旨_塩_酸_甘", "U_3"],
  ["苦_酸甘_旨_甘_旨_塩_酸_酸", "U_3"],
  ["苦_酸甘_旨_甘_旨_塩_酸_塩", "C_1"],
  ["苦_酸甘_旨_甘_旨_塩_甘_苦塩", "A_1"],
  ["苦_酸甘_旨_甘_旨_塩_甘_旨", "A_3"],
  ["苦_酸甘_旨_甘_旨_塩_甘_甘", "A_1"],
  ["苦_酸甘_旨_甘_旨_塩_甘_酸", "U_3"],
  ["苦_酸甘_旨_甘_旨_塩_甘_塩", "A_3"],
  ["苦_酸甘_旨_甘_旨_甘_旨_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_甘_旨_旨", "A_4"],
  ["苦_酸甘_旨_甘_旨_甘_旨_甘", "A_4"],
  ["苦_酸甘_旨_甘_旨_甘_旨_酸", "U_2"],
  ["苦_酸甘_旨_甘_旨_甘_旨_塩", "A_3"],
  ["苦_酸甘_旨_甘_旨_甘_酸甘_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_甘_酸甘_旨", "A_4"],
  ["苦_酸甘_旨_甘_旨_甘_酸甘_甘", "A_1"],
  ["苦_酸甘_旨_甘_旨_甘_酸甘_酸", "U_3"],
  ["苦_酸甘_旨_甘_旨_甘_酸甘_塩", "A_1"],
  ["苦_酸甘_旨_甘_旨_甘_苦_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_甘_苦_旨", "A_2"],
  ["苦_酸甘_旨_甘_旨_甘_苦_甘", "A_2"],
  ["苦_酸甘_旨_甘_旨_甘_苦_酸", "A_2"],
  ["苦_酸甘_旨_甘_旨_甘_苦_塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_甘_酸_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_甘_酸_旨", "U_2"],
  ["苦_酸甘_旨_甘_旨_甘_酸_甘", "A_1"],
  ["苦_酸甘_旨_甘_旨_甘_酸_酸", "U_3"],
  ["苦_酸甘_旨_甘_旨_甘_酸_塩", "U_3"],
  ["苦_酸甘_旨_甘_旨_甘_甘_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_甘_甘_旨", "A_4"],
  ["苦_酸甘_旨_甘_旨_甘_甘_甘", "A_1"],
  ["苦_酸甘_旨_甘_旨_甘_甘_酸", "A_1"],
  ["苦_酸甘_旨_甘_旨_甘_甘_塩", "A_1"],
  ["苦_酸甘_旨_甘_旨_酸_旨_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_酸_旨_旨", "U_2"],
  ["苦_酸甘_旨_甘_旨_酸_旨_甘", "U_2"],
  ["苦_酸甘_旨_甘_旨_酸_旨_酸", "U_2"],
  ["苦_酸甘_旨_甘_旨_酸_旨_塩", "U_2"],
  ["苦_酸甘_旨_甘_旨_酸_酸甘_苦塩", "U_3"],
  ["苦_酸甘_旨_甘_旨_酸_酸甘_旨", "U_2"],
  ["苦_酸甘_旨_甘_旨_酸_酸甘_甘", "U_3"],
  ["苦_酸甘_旨_甘_旨_酸_酸甘_酸", "U_3"],
  ["苦_酸甘_旨_甘_旨_酸_酸甘_塩", "U_3"],
  ["苦_酸甘_旨_甘_旨_酸_苦_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_酸_苦_旨", "A_2"],
  ["苦_酸甘_旨_甘_旨_酸_苦_甘", "A_2"],
  ["苦_酸甘_旨_甘_旨_酸_苦_酸", "A_2"],
  ["苦_酸甘_旨_甘_旨_酸_苦_塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_酸_酸_苦塩", "U_3"],
  ["苦_酸甘_旨_甘_旨_酸_酸_旨", "U_2"],
  ["苦_酸甘_旨_甘_旨_酸_酸_甘", "U_3"],
  ["苦_酸甘_旨_甘_旨_酸_酸_酸", "U_3"],
  ["苦_酸甘_旨_甘_旨_酸_酸_塩", "U_3"],
  ["苦_酸甘_旨_甘_旨_酸_甘_苦塩", "A_2"],
  ["苦_酸甘_旨_甘_旨_酸_甘_旨", "U_2"],
  ["苦_酸甘_旨_甘_旨_酸_甘_甘", "A_1"],
  ["苦_酸甘_旨_甘_旨_酸_甘_酸", "U_3"],
  ["苦_苦酸_塩_甘_旨_酸_甘_塩", "B_2"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_旨_苦塩", "N_1"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_旨_旨", "N_1"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_旨_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_旨_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_旨_塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_酸甘_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_酸甘_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_酸甘_甘", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_酸甘_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_酸甘_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_苦_旨", "N_1"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_苦_甘", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_苦_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_苦_塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_酸_苦塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_酸_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_酸_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_酸_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_酸_塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_甘_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_甘_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_甘_甘", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_甘_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_旨_甘_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_旨_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_旨_旨", "N_1"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_旨_甘", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_旨_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_旨_塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_酸甘_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_酸甘_旨", "N_3"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_酸甘_甘", "N_3"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_酸甘_酸", "N_3"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_酸甘_塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_苦_旨", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_苦_甘", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_苦_酸", "N_3"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_苦_塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_酸_苦塩", "N_3"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_酸_旨", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_酸_甘", "N_3"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_酸_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_酸_塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_甘_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_甘_旨", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_甘_甘", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_甘_酸", "N_3"],
  ["苦_苦酸_塩_旨塩_苦塩_苦_甘_塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_旨_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_旨_旨", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_旨_甘", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_旨_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_旨_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_酸甘_苦塩", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_酸甘_旨", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_酸甘_甘", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_酸甘_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_酸甘_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_苦_旨", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_苦_甘", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_苦_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_苦_塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_酸_苦塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_酸_旨", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_酸_甘", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_酸_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_酸_塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_甘_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_甘_旨", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_甘_甘", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_甘_酸", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_塩_甘_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_旨_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_旨_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_旨_甘", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_旨_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_旨_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_酸甘_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_酸甘_旨", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_酸甘_甘", "B_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_酸甘_酸", "B_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_酸甘_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_苦_旨", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_苦_甘", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_苦_酸", "N_3"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_苦_塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_酸_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_酸_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_酸_甘", "B_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_酸_酸", "S_1"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_酸_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_甘_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_甘_旨", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_甘_甘", "B_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_甘_酸", "B_2"],
  ["苦_苦酸_塩_旨塩_苦塩_甘_甘_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_旨_苦塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_旨_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_旨_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_旨_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_旨_塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_酸甘_苦塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_酸甘_旨", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_酸甘_甘", "B_2"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_酸甘_酸", "S_1"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_酸甘_塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_苦_苦塩", "N_3"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_苦_旨", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_苦_甘", "N_3"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_苦_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_苦_塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_酸_苦塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_酸_旨", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_酸_甘", "S_1"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_酸_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_酸_塩", "N_4"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_甘_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_甘_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_甘_甘", "B_2"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_甘_酸", "S_1"],
  ["苦_苦酸_塩_旨塩_苦塩_酸_甘_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_旨_旨_旨_苦塩", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_旨_旨", "U_4"],
  ["苦_苦酸_塩_旨塩_旨_旨_旨_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_旨_酸", "U_4"],
  ["苦_苦酸_塩_旨塩_旨_旨_旨_塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_酸甘_苦塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_酸甘_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_酸甘_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_酸甘_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_酸甘_塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_苦_苦塩", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_苦_旨", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_苦_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_苦_酸", "B_3"],
  ["苦_苦酸_塩_旨塩_旨_旨_苦_塩", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_酸_苦塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_酸_旨", "U_4"],
  ["苦_苦酸_塩_旨塩_旨_旨_酸_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_酸_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_酸_塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_甘_苦塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_甘_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_甘_甘", "U_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_甘_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_旨_甘_塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_旨_苦塩", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_旨_旨", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_旨_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_旨_酸", "B_3"],
  ["苦_苦酸_塩_旨塩_旨_苦_旨_塩", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_酸甘_苦塩", "N_3"],
  ["苦_苦酸_塩_旨塩_旨_苦_酸甘_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_酸甘_甘", "N_3"],
  ["苦_苦酸_塩_旨塩_旨_苦_酸甘_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_酸甘_塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_旨_苦_苦_旨", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_苦_甘", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_苦_酸", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_苦_塩", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_酸_苦塩", "N_4"],
  ["苦_苦酸_塩_旨塩_旨_苦_酸_旨", "B_3"],
  ["苦_苦酸_塩_旨塩_旨_苦_酸_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_酸_酸", "B_3"],
  ["苦_苦酸_塩_旨塩_旨_苦_酸_塩", "N_4"],
  ["苦_苦酸_塩_旨塩_旨_苦_甘_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_旨_苦_甘_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_甘_甘", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_甘_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_苦_甘_塩", "N_2"],
  ["苦_苦酸_塩_旨塩_旨_塩_旨_苦塩", "N_4"],
  ["苦_苦酸_塩_旨塩_旨_塩_旨_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_旨_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_旨_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_旨_塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_酸甘_苦塩", "N_5"],
  ["苦_苦酸_塩_旨塩_旨_塩_酸甘_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_酸甘_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_酸甘_酸", "S_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_酸甘_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_旨_塩_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_旨_塩_苦_旨", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_苦_甘", "N_2"],
  ["苦_苦酸_塩_旨塩_旨_塩_苦_酸", "N_4"],
  ["苦_苦酸_塩_旨塩_旨_塩_苦_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_旨_塩_酸_苦塩", "N_4"],
  ["苦_苦酸_塩_旨塩_旨_塩_酸_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_酸_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_酸_酸", "S_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_酸_塩", "N_4"],
  ["苦_苦酸_塩_旨塩_旨_塩_甘_苦塩", "N_5"],
  ["苦_苦酸_塩_旨塩_旨_塩_甘_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_甘_甘", "N_5"],
  ["苦_苦酸_塩_旨塩_旨_塩_甘_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_塩_甘_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_旨_甘_旨_苦塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_旨_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_旨_甘", "U_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_旨_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_旨_塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_酸甘_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_旨_甘_酸甘_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_酸甘_甘", "C_2"],
  ["苦_苦酸_塩_旨塩_旨_甘_酸甘_酸", "U_3"],
  ["苦_苦酸_塩_旨塩_旨_甘_酸甘_塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_旨_甘_苦_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_苦_甘", "N_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_苦_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_苦_塩", "N_2"],
  ["苦_苦酸_塩_旨塩_旨_甘_酸_苦塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_酸_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_酸_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_酸_酸", "S_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_酸_塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_甘_苦塩", "N_2"],
  ["苦_苦酸_塩_旨塩_旨_甘_甘_旨", "U_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_甘_甘", "A_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_甘_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_甘_甘_塩", "N_5"],
  ["苦_苦酸_塩_旨塩_旨_酸_旨_苦塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_旨_旨", "U_4"],
  ["苦_苦酸_塩_旨塩_旨_酸_旨_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_旨_酸", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_旨_塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_酸甘_苦塩", "N_4"],
  ["苦_苦酸_塩_旨塩_旨_酸_酸甘_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_酸甘_甘", "U_3"],
  ["苦_苦酸_塩_旨塩_旨_酸_酸甘_酸", "S_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_酸甘_塩", "S_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_苦_苦塩", "N_4"],
  ["苦_苦酸_塩_旨塩_旨_酸_苦_旨", "B_3"],
  ["苦_苦酸_塩_旨塩_旨_酸_苦_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_苦_酸", "B_3"],
  ["苦_苦酸_塩_旨塩_旨_酸_苦_塩", "N_4"],
  ["苦_苦酸_塩_旨塩_旨_酸_酸_苦塩", "N_4"],
  ["苦_苦酸_塩_旨塩_旨_酸_酸_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_酸_甘", "S_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_酸_酸", "S_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_酸_塩", "S_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_甘_苦塩", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_甘_旨", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_甘_甘", "B_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_甘_酸", "S_1"],
  ["苦_苦酸_塩_旨塩_旨_酸_甘_塩", "B_1"],
  ["苦_苦酸_塩_甘_苦塩_旨_旨_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_旨_旨", "B_1"],
  ["苦_苦酸_塩_甘_苦塩_旨_旨_甘", "N_1"],
  ["苦_苦酸_塩_甘_苦塩_旨_旨_酸", "B_1"],
  ["苦_苦酸_塩_甘_苦塩_旨_旨_塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_酸甘_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_旨_酸甘_旨", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_旨_酸甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_酸甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_酸甘_塩", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_苦_旨", "N_1"],
  ["苦_苦酸_塩_甘_苦塩_旨_苦_甘", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_苦_酸", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_旨_苦_塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_酸_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_旨_酸_旨", "B_1"],
  ["苦_苦酸_塩_甘_苦塩_旨_酸_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_酸_酸", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_酸_塩", "N_5"],
  ["苦_苦酸_塩_甘_苦塩_旨_甘_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_甘_旨", "N_1"],
  ["苦_苦酸_塩_甘_苦塩_旨_甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_旨_甘_塩", "N_5"],
  ["苦_苦酸_塩_甘_苦塩_苦_旨_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_苦_旨_旨", "N_1"],
  ["苦_苦酸_塩_甘_苦塩_苦_旨_甘", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_苦_旨_酸", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_苦_旨_塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_苦_酸甘_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_苦_酸甘_旨", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_苦_酸甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_苦_酸甘_酸", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_苦_酸甘_塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_苦_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_苦_苦_旨", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_苦_苦_甘", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_苦_苦_酸", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_苦_苦_塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_苦_酸_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_苦_酸_旨", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_苦_酸_甘", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_苦_酸_酸", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_苦_酸_塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_苦_甘_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_苦_甘_旨", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_苦_甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_苦_甘_酸", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_苦_甘_塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_旨_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_旨_旨", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_旨_甘", "N_5"],
  ["苦_苦酸_塩_甘_苦塩_塩_旨_酸", "N_5"],
  ["苦_苦酸_塩_甘_苦塩_塩_旨_塩", "N_5"],
  ["苦_苦酸_塩_甘_苦塩_塩_酸甘_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_酸甘_旨", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_酸甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_酸甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_酸甘_塩", "N_5"],
  ["苦_苦酸_塩_甘_苦塩_塩_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_苦_旨", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_苦_甘", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_苦_酸", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_塩_苦_塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_酸_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_塩_酸_旨", "N_5"],
  ["苦_苦酸_塩_甘_苦塩_塩_酸_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_酸_酸", "S_1"],
  ["苦_苦酸_塩_甘_苦塩_塩_酸_塩", "N_5"],
  ["苦_苦酸_塩_甘_苦塩_塩_甘_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_甘_旨", "N_5"],
  ["苦_苦酸_塩_甘_苦塩_塩_甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_塩_甘_塩", "N_5"],
  ["苦_苦酸_塩_甘_苦塩_甘_旨_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_旨_旨", "N_1"],
  ["苦_苦酸_塩_甘_苦塩_甘_旨_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_旨_酸", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_旨_塩", "N_5"],
  ["苦_苦酸_塩_甘_苦塩_甘_酸甘_苦塩", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_酸甘_旨", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_酸甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_酸甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_酸甘_塩", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_苦_旨", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_苦_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_苦_酸", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_甘_苦_塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_酸_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_甘_酸_旨", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_酸_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_酸_酸", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_酸_塩", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_甘_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_甘_旨", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_甘_甘_塩", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_酸_旨_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_酸_旨_旨", "B_1"],
  ["苦_苦酸_塩_甘_苦塩_酸_旨_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_酸_旨_酸", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_酸_旨_塩", "N_5"],
  ["苦_苦酸_塩_甘_苦塩_酸_酸甘_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_酸_酸甘_旨", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_酸_酸甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_酸_酸甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_酸_酸甘_塩", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_酸_苦_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_酸_苦_旨", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_酸_苦_甘", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_酸_苦_酸", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_酸_苦_塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_酸_酸_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_酸_酸_旨", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_酸_酸_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_酸_酸_酸", "S_1"],
  ["苦_苦酸_塩_甘_苦塩_酸_酸_塩", "S_1"],
  ["苦_苦酸_塩_甘_苦塩_酸_甘_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_苦塩_酸_甘_旨", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_酸_甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_酸_甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_苦塩_酸_甘_塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_旨_旨_苦塩", "B_1"],
  ["苦_苦酸_塩_甘_旨_旨_旨_旨", "U_1"],
  ["苦_苦酸_塩_甘_旨_旨_旨_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_旨_旨_酸", "B_1"],
  ["苦_苦酸_塩_甘_旨_旨_旨_塩", "B_1"],
  ["苦_苦酸_塩_甘_旨_旨_酸甘_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_旨_旨_酸甘_旨", "A_2"],
  ["苦_苦酸_塩_甘_旨_旨_酸甘_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_旨_酸甘_酸", "U_3"],
  ["苦_苦酸_塩_甘_旨_旨_酸甘_塩", "B_1"],
  ["苦_苦酸_塩_甘_旨_旨_苦_苦塩", "N_1"],
  ["苦_苦酸_塩_甘_旨_旨_苦_旨", "B_3"],
  ["苦_苦酸_塩_甘_旨_旨_苦_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_旨_苦_酸", "B_3"],
  ["苦_苦酸_塩_甘_旨_旨_苦_塩", "B_1"],
  ["苦_苦酸_塩_甘_旨_旨_酸_苦塩", "B_1"],
  ["苦_苦酸_塩_甘_旨_旨_酸_旨", "B_1"],
  ["苦_苦酸_塩_甘_旨_旨_酸_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_旨_酸_酸", "B_3"],
  ["苦_苦酸_塩_甘_旨_旨_酸_塩", "B_1"],
  ["苦_苦酸_塩_甘_旨_旨_甘_苦塩", "N_1"],
  ["苦_苦酸_塩_甘_旨_旨_甘_旨", "A_2"],
  ["苦_苦酸_塩_甘_旨_旨_甘_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_旨_甘_酸", "A_2"],
  ["苦_苦酸_塩_甘_旨_旨_甘_塩", "A_2"],
  ["苦_苦酸_塩_甘_旨_苦_旨_苦塩", "N_1"],
  ["苦_苦酸_塩_甘_旨_苦_旨_旨", "B_3"],
  ["苦_苦酸_塩_甘_旨_苦_旨_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_苦_旨_酸", "B_3"],
  ["苦_苦酸_塩_甘_旨_苦_旨_塩", "B_1"],
  ["苦_苦酸_塩_甘_旨_苦_酸甘_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_旨_苦_酸甘_旨", "A_2"],
  ["苦_苦酸_塩_甘_旨_苦_酸甘_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_苦_酸甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_苦_酸甘_塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_苦_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_旨_苦_苦_旨", "N_1"],
  ["苦_苦酸_塩_甘_旨_苦_苦_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_苦_苦_酸", "N_3"],
  ["苦_苦酸_塩_甘_旨_苦_苦_塩", "N_2"],
  ["苦_苦酸_塩_甘_旨_苦_酸_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_旨_苦_酸_旨", "B_3"],
  ["苦_苦酸_塩_甘_旨_苦_酸_甘", "B_2"],
  ["苦_苦酸_塩_甘_旨_苦_酸_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_苦_酸_塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_苦_甘_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_旨_苦_甘_旨", "A_2"],
  ["苦_苦酸_塩_甘_旨_苦_甘_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_苦_甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_苦_甘_塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_塩_旨_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_旨_塩_旨_旨", "B_1"],
  ["苦_苦酸_塩_甘_旨_塩_旨_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_塩_旨_酸", "B_1"],
  ["苦_苦酸_塩_甘_旨_塩_旨_塩", "B_1"],
  ["苦_苦酸_塩_甘_旨_塩_酸甘_苦塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_塩_酸甘_旨", "B_1"],
  ["苦_苦酸_塩_甘_旨_塩_酸甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_旨_塩_酸甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_塩_酸甘_塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_塩_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_旨_塩_苦_旨", "B_1"],
  ["苦_苦酸_塩_甘_旨_塩_苦_甘", "B_2"],
  ["苦_苦酸_塩_甘_旨_塩_苦_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_塩_苦_塩", "N_5"],
  ["苦_苦酸_塩_甘_旨_塩_酸_苦塩", "N_5"],
  ["苦_苦酸_塩_甘_旨_塩_酸_旨", "B_1"],
  ["苦_苦酸_塩_甘_旨_塩_酸_甘", "B_2"],
  ["苦_苦酸_塩_甘_旨_塩_酸_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_塩_酸_塩", "N_5"],
  ["苦_苦酸_塩_甘_旨_塩_甘_苦塩", "N_5"],
  ["苦_苦酸_塩_甘_旨_塩_甘_旨", "A_2"],
  ["苦_苦酸_塩_甘_旨_塩_甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_旨_塩_甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_塩_甘_塩", "N_5"],
  ["苦_苦酸_塩_甘_旨_甘_旨_苦塩", "N_1"],
  ["苦_苦酸_塩_甘_旨_甘_旨_旨", "A_2"],
  ["苦_苦酸_塩_甘_旨_甘_旨_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_甘_旨_酸", "A_2"],
  ["苦_苦酸_塩_甘_旨_甘_旨_塩", "A_2"],
  ["苦_苦酸_塩_甘_旨_甘_酸甘_苦塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_甘_酸甘_旨", "A_2"],
  ["苦_苦酸_塩_甘_旨_甘_酸甘_甘", "A_1"],
  ["苦_苦酸_塩_甘_旨_甘_酸甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_甘_酸甘_塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_甘_苦_苦塩", "N_2"],
  ["苦_苦酸_塩_甘_旨_甘_苦_旨", "A_2"],
  ["苦_苦酸_塩_甘_旨_甘_苦_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_甘_苦_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_甘_苦_塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_甘_酸_苦塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_甘_酸_旨", "A_2"],
  ["苦_苦酸_塩_甘_旨_甘_酸_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_甘_酸_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_甘_酸_塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_甘_甘_苦塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_甘_甘_旨", "A_2"],
  ["苦_苦酸_塩_甘_旨_甘_甘_甘", "A_1"],
  ["苦_苦酸_塩_甘_旨_甘_甘_酸", "A_2"],
  ["苦_苦酸_塩_甘_旨_甘_甘_塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_旨_苦塩", "B_1"],
  ["苦_苦酸_塩_甘_旨_酸_旨_旨", "B_1"],
  ["苦_苦酸_塩_甘_旨_酸_旨_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_酸_旨_酸", "B_3"],
  ["苦_苦酸_塩_甘_旨_酸_旨_塩", "B_1"],
  ["苦_苦酸_塩_甘_旨_酸_酸甘_苦塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_酸甘_旨", "U_3"],
  ["苦_苦酸_塩_甘_旨_酸_酸甘_甘", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_酸甘_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_酸甘_塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_苦_苦塩", "N_3"],
  ["苦_苦酸_塩_甘_旨_酸_苦_旨", "B_3"],
  ["苦_苦酸_塩_甘_旨_酸_苦_甘", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_苦_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_苦_塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_酸_苦塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_酸_旨", "B_3"],
  ["苦_苦酸_塩_甘_旨_酸_酸_甘", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_酸_酸", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_酸_塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_甘_苦塩", "B_2"],
  ["苦_苦酸_塩_甘_旨_酸_甘_旨", "A_2"],
  ["苦_苦酸_塩_甘_旨_酸_甘_甘", "A_2"],
  ["苦_苦酸_塩_甘_旨_酸_甘_酸", "B_2"],
  ["苦_苦酸_旨_甘_旨_酸_甘_塩", "A_2"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_旨_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_旨_旨", "U_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_旨_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_旨_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_旨_塩", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_酸甘_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_酸甘_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_酸甘_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_酸甘_酸", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_酸甘_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_苦_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_苦_旨", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_苦_甘", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_苦_酸", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_苦_塩", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_酸_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_酸_旨", "B_3"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_酸_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_酸_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_酸_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_甘_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_甘_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_甘_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_甘_酸", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_旨_甘_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_旨_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_旨_旨", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_旨_甘", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_旨_酸", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_旨_塩", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_酸甘_苦塩", "N_3"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_酸甘_旨", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_酸甘_甘", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_酸甘_酸", "N_3"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_酸甘_塩", "N_3"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_苦_苦塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_苦_旨", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_苦_甘", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_苦_酸", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_苦_塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_酸_苦塩", "N_3"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_酸_旨", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_酸_甘", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_酸_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_酸_塩", "N_4"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_甘_苦塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_甘_旨", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_甘_甘", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_甘_酸", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_苦_甘_塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_旨_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_旨_旨", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_旨_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_旨_酸", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_旨_塩", "N_4"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_酸甘_苦塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_酸甘_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_酸甘_甘", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_酸甘_酸", "N_4"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_酸甘_塩", "N_5"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_苦_苦塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_苦_旨", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_苦_甘", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_苦_酸", "N_4"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_苦_塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_酸_苦塩", "N_4"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_酸_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_酸_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_酸_酸", "N_4"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_酸_塩", "N_4"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_甘_苦塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_甘_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_甘_甘", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_甘_酸", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_塩_甘_塩", "N_5"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_旨_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_旨_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_旨_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_旨_酸", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_旨_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_酸甘_苦塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_酸甘_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_酸甘_甘", "A_2"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_酸甘_酸", "B_2"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_酸甘_塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_苦_苦塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_苦_旨", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_苦_甘", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_苦_酸", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_苦_塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_酸_苦塩", "N_3"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_酸_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_酸_甘", "N_3"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_酸_酸", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_酸_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_甘_苦塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_甘_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_甘_甘", "A_2"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_甘_酸", "N_3"],
  ["苦_苦酸_旨_旨塩_苦塩_甘_甘_塩", "N_2"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_旨_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_旨_旨", "B_3"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_旨_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_旨_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_旨_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_酸甘_苦塩", "N_3"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_酸甘_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_酸甘_甘", "B_2"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_酸甘_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_酸甘_塩", "N_4"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_苦_苦塩", "N_3"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_苦_旨", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_苦_甘", "N_1"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_苦_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_苦_塩", "N_4"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_酸_苦塩", "N_4"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_酸_旨", "B_3"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_酸_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_酸_酸", "N_4"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_酸_塩", "N_4"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_甘_苦塩", "N_3"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_甘_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_甘_甘", "N_3"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_甘_酸", "B_1"],
  ["苦_苦酸_旨_旨塩_苦塩_酸_甘_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_旨_苦塩", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_旨_旨", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_旨_甘", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_旨_酸", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_旨_旨_塩", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_旨_酸甘_苦塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_酸甘_旨", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_旨_酸甘_甘", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_酸甘_酸", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_旨_酸甘_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_苦_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_苦_旨", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_苦_甘", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_苦_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_旨_苦_塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_酸_苦塩", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_旨_酸_旨", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_旨_酸_甘", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_旨_酸_酸", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_旨_酸_塩", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_旨_甘_苦塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_甘_旨", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_甘_甘", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_旨_甘_酸", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_旨_甘_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_旨_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_旨_旨", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_旨_甘", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_旨_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_苦_旨_塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_酸甘_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_酸甘_旨", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_酸甘_甘", "A_2"],
  ["苦_苦酸_旨_旨塩_旨_苦_酸甘_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_苦_酸甘_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_苦_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_苦_旨", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_苦_甘", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_苦_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_苦_苦_塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_酸_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_酸_旨", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_苦_酸_甘", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_苦_酸_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_苦_酸_塩", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_苦_甘_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_甘_旨", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_苦_甘_甘", "A_2"],
  ["苦_苦酸_旨_旨塩_旨_苦_甘_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_苦_甘_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_旨_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_旨_旨", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_塩_旨_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_旨_酸", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_塩_旨_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_酸甘_苦塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_酸甘_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_酸甘_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_酸甘_酸", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_酸甘_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_苦_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_苦_旨", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_苦_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_苦_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_塩_苦_塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_酸_苦塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_酸_旨", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_塩_酸_甘", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_酸_酸", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_酸_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_甘_苦塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_甘_旨", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_甘_甘", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_甘_酸", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_塩_甘_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_旨_苦塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_旨_旨", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_旨_甘", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_旨_酸", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_甘_旨_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_酸甘_苦塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_酸甘_旨", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_酸甘_甘", "A_2"],
  ["苦_苦酸_旨_旨塩_旨_甘_酸甘_酸", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_甘_酸甘_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_苦_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_苦_旨", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_苦_甘", "A_2"],
  ["苦_苦酸_旨_旨塩_旨_甘_苦_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_甘_苦_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_酸_苦塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_酸_旨", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_甘_酸_甘", "A_2"],
  ["苦_苦酸_旨_旨塩_旨_甘_酸_酸", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_甘_酸_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_甘_苦塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_甘_旨", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_甘_甘_甘", "A_2"],
  ["苦_苦酸_旨_旨塩_旨_甘_甘_酸", "A_2"],
  ["苦_苦酸_旨_旨塩_旨_甘_甘_塩", "U_1"],
  ["苦_苦酸_旨_旨塩_旨_酸_旨_苦塩", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_酸_旨_旨", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_酸_旨_甘", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_酸_旨_酸", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_酸_旨_塩", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_酸_酸甘_苦塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_酸_酸甘_旨", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_酸_酸甘_甘", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_酸_酸甘_酸", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_酸_酸甘_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_酸_苦_苦塩", "N_1"],
  ["苦_苦酸_旨_旨塩_旨_酸_苦_旨", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_酸_苦_甘", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_酸_苦_酸", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_酸_苦_塩", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_酸_酸_苦塩", "B_3"],
  ["苦_苦酸_旨_旨塩_旨_酸_酸_旨", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_酸_酸_甘", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_酸_酸_酸", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_酸_酸_塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_酸_甘_苦塩", "B_1"],
  ["苦_苦酸_旨_旨塩_旨_酸_甘_旨", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_酸_甘_甘", "A_2"],
  ["苦_苦酸_旨_旨塩_旨_酸_甘_酸", "U_4"],
  ["苦_苦酸_旨_旨塩_旨_酸_甘_塩", "B_1"],
  ["苦_苦酸_旨_甘_苦塩_旨_旨_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_旨_旨_旨", "U_1"],
  ["苦_苦酸_旨_甘_苦塩_旨_旨_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_旨_旨_酸", "B_3"],
  ["苦_苦酸_旨_甘_苦塩_旨_旨_塩", "B_1"],
  ["苦_苦酸_旨_甘_苦塩_旨_酸甘_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_旨_酸甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_旨_酸甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_旨_酸甘_酸", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_旨_酸甘_塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_旨_苦_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_旨_苦_旨", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_旨_苦_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_旨_苦_酸", "B_3"],
  ["苦_苦酸_旨_甘_苦塩_旨_苦_塩", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_旨_酸_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_旨_酸_旨", "B_3"],
  ["苦_苦酸_旨_甘_苦塩_旨_酸_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_旨_酸_酸", "B_3"],
  ["苦_苦酸_旨_甘_苦塩_旨_酸_塩", "B_1"],
  ["苦_苦酸_旨_甘_苦塩_旨_甘_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_旨_甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_旨_甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_旨_甘_酸", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_旨_甘_塩", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_苦_旨_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_苦_旨_旨", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_苦_旨_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_苦_旨_酸", "B_3"],
  ["苦_苦酸_旨_甘_苦塩_苦_旨_塩", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_苦_酸甘_苦塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_苦_酸甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_苦_酸甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_苦_酸甘_酸", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_苦_酸甘_塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_苦_苦_苦塩", "N_2"],
  ["苦_苦酸_旨_甘_苦塩_苦_苦_旨", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_苦_苦_甘", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_苦_苦_酸", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_苦_苦_塩", "N_2"],
  ["苦_苦酸_旨_甘_苦塩_苦_酸_苦塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_苦_酸_旨", "B_3"],
  ["苦_苦酸_旨_甘_苦塩_苦_酸_甘", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_苦_酸_酸", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_苦_酸_塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_苦_甘_苦塩", "N_2"],
  ["苦_苦酸_旨_甘_苦塩_苦_甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_苦_甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_苦_甘_酸", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_苦_甘_塩", "N_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_旨_苦塩", "N_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_旨_旨", "B_1"],
  ["苦_苦酸_旨_甘_苦塩_塩_旨_甘", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_塩_旨_酸", "B_1"],
  ["苦_苦酸_旨_甘_苦塩_塩_旨_塩", "N_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_酸甘_苦塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_塩_酸甘_旨", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_塩_酸甘_甘", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_酸甘_酸", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_酸甘_塩", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_苦_苦塩", "N_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_苦_旨", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_塩_苦_甘", "N_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_苦_酸", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_塩_苦_塩", "N_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_酸_苦塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_塩_酸_旨", "B_1"],
  ["苦_苦酸_旨_甘_苦塩_塩_酸_甘", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_酸_酸", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_酸_塩", "N_5"],
  ["苦_苦酸_旨_甘_苦塩_塩_甘_苦塩", "N_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_甘_旨", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_塩_甘_甘", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_甘_酸", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_塩_甘_塩", "N_5"],
  ["苦_苦酸_旨_甘_苦塩_甘_旨_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_甘_旨_旨", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_旨_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_旨_酸", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_旨_塩", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_甘_酸甘_苦塩", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_酸甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_酸甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_酸甘_酸", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_酸甘_塩", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_苦_苦塩", "N_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_苦_旨", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_苦_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_苦_酸", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_苦_塩", "N_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_酸_苦塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_甘_酸_旨", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_酸_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_酸_酸", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_酸_塩", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_甘_苦塩", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_甘_酸", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_甘_甘_塩", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_旨_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_苦塩_酸_旨_旨", "B_3"],
  ["苦_苦酸_旨_甘_苦塩_酸_旨_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_旨_酸", "B_3"],
  ["苦_苦酸_旨_甘_苦塩_酸_旨_塩", "B_1"],
  ["苦_苦酸_旨_甘_苦塩_酸_酸甘_苦塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_酸_酸甘_旨", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_酸甘_甘", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_酸甘_酸", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_酸甘_塩", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_苦_苦塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_酸_苦_旨", "B_3"],
  ["苦_苦酸_旨_甘_苦塩_酸_苦_甘", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_苦_酸", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_酸_苦_塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_酸_酸_苦塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_酸_酸_旨", "B_3"],
  ["苦_苦酸_旨_甘_苦塩_酸_酸_甘", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_酸_酸", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_酸_塩", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_甘_苦塩", "N_3"],
  ["苦_苦酸_旨_甘_苦塩_酸_甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_甘_酸", "B_2"],
  ["苦_苦酸_旨_甘_苦塩_酸_甘_塩", "B_2"],
  ["苦_苦酸_旨_甘_旨_旨_旨_苦塩", "U_1"],
  ["苦_苦酸_旨_甘_旨_旨_旨_旨", "U_1"],
  ["苦_苦酸_旨_甘_旨_旨_旨_甘", "U_1"],
  ["苦_苦酸_旨_甘_旨_旨_旨_酸", "U_4"],
  ["苦_苦酸_旨_甘_旨_旨_旨_塩", "U_1"],
  ["苦_苦酸_旨_甘_旨_旨_酸甘_苦塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_旨_酸甘_旨", "U_1"],
  ["苦_苦酸_旨_甘_旨_旨_酸甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_旨_酸甘_酸", "U_4"],
  ["苦_苦酸_旨_甘_旨_旨_酸甘_塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_旨_苦_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_旨_旨_苦_旨", "U_1"],
  ["苦_苦酸_旨_甘_旨_旨_苦_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_旨_苦_酸", "B_3"],
  ["苦_苦酸_旨_甘_旨_旨_苦_塩", "B_3"],
  ["苦_苦酸_旨_甘_旨_旨_酸_苦塩", "B_3"],
  ["苦_苦酸_旨_甘_旨_旨_酸_旨", "U_4"],
  ["苦_苦酸_旨_甘_旨_旨_酸_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_旨_酸_酸", "U_4"],
  ["苦_苦酸_旨_甘_旨_旨_酸_塩", "B_1"],
  ["苦_苦酸_旨_甘_旨_旨_甘_苦塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_旨_甘_旨", "U_1"],
  ["苦_苦酸_旨_甘_旨_旨_甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_旨_甘_酸", "A_2"],
  ["苦_苦酸_旨_甘_旨_旨_甘_塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_旨_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_旨_苦_旨_旨", "U_1"],
  ["苦_苦酸_旨_甘_旨_苦_旨_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_旨_酸", "B_3"],
  ["苦_苦酸_旨_甘_旨_苦_旨_塩", "B_3"],
  ["苦_苦酸_旨_甘_旨_苦_酸甘_苦塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_酸甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_酸甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_酸甘_酸", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_酸甘_塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_苦_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_旨_苦_苦_旨", "B_3"],
  ["苦_苦酸_旨_甘_旨_苦_苦_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_苦_酸", "B_3"],
  ["苦_苦酸_旨_甘_旨_苦_苦_塩", "N_1"],
  ["苦_苦酸_旨_甘_旨_苦_酸_苦塩", "B_3"],
  ["苦_苦酸_旨_甘_旨_苦_酸_旨", "B_3"],
  ["苦_苦酸_旨_甘_旨_苦_酸_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_酸_酸", "B_3"],
  ["苦_苦酸_旨_甘_旨_苦_酸_塩", "B_3"],
  ["苦_苦酸_旨_甘_旨_苦_甘_苦塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_甘_酸", "A_2"],
  ["苦_苦酸_旨_甘_旨_苦_甘_塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_塩_旨_苦塩", "B_1"],
  ["苦_苦酸_旨_甘_旨_塩_旨_旨", "U_1"],
  ["苦_苦酸_旨_甘_旨_塩_旨_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_塩_旨_酸", "B_1"],
  ["苦_苦酸_旨_甘_旨_塩_旨_塩", "B_1"],
  ["苦_苦酸_旨_甘_旨_塩_酸甘_苦塩", "N_3"],
  ["苦_苦酸_旨_甘_旨_塩_酸甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_旨_塩_酸甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_塩_酸甘_酸", "U_3"],
  ["苦_苦酸_旨_甘_旨_塩_酸甘_塩", "B_1"],
  ["苦_苦酸_旨_甘_旨_塩_苦_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_旨_塩_苦_旨", "B_3"],
  ["苦_苦酸_旨_甘_旨_塩_苦_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_塩_苦_酸", "B_3"],
  ["苦_苦酸_旨_甘_旨_塩_苦_塩", "B_1"],
  ["苦_苦酸_旨_甘_旨_塩_酸_苦塩", "B_1"],
  ["苦_苦酸_旨_甘_旨_塩_酸_旨", "B_1"],
  ["苦_苦酸_旨_甘_旨_塩_酸_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_塩_酸_酸", "B_3"],
  ["苦_苦酸_旨_甘_旨_塩_酸_塩", "B_1"],
  ["苦_苦酸_旨_甘_旨_塩_甘_苦塩", "N_1"],
  ["苦_苦酸_旨_甘_旨_塩_甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_旨_塩_甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_塩_甘_酸", "A_2"],
  ["苦_苦酸_旨_甘_旨_塩_甘_塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_旨_苦塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_旨_旨", "U_1"],
  ["苦_苦酸_旨_甘_旨_甘_旨_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_旨_酸", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_旨_塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_酸甘_苦塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_酸甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_酸甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_酸甘_酸", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_酸甘_塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_苦_苦塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_苦_旨", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_苦_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_苦_酸", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_苦_塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_酸_苦塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_酸_旨", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_酸_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_酸_酸", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_酸_塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_甘_苦塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_甘_酸", "A_2"],
  ["苦_苦酸_旨_甘_旨_甘_甘_塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_酸_旨_苦塩", "B_3"],
  ["苦_苦酸_旨_甘_旨_酸_旨_旨", "U_4"],
  ["苦_苦酸_旨_甘_旨_酸_旨_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_酸_旨_酸", "U_4"],
  ["苦_苦酸_旨_甘_旨_酸_旨_塩", "B_1"],
  ["苦_苦酸_旨_甘_旨_酸_酸甘_苦塩", "B_2"],
  ["苦_苦酸_旨_甘_旨_酸_酸甘_旨", "U_4"],
  ["苦_苦酸_旨_甘_旨_酸_酸甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_酸_酸甘_酸", "U_3"],
  ["苦_苦酸_旨_甘_旨_酸_酸甘_塩", "U_3"],
  ["苦_苦酸_旨_甘_旨_酸_苦_苦塩", "B_3"],
  ["苦_苦酸_旨_甘_旨_酸_苦_旨", "B_3"],
  ["苦_苦酸_旨_甘_旨_酸_苦_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_酸_苦_酸", "B_3"],
  ["苦_苦酸_旨_甘_旨_酸_苦_塩", "B_3"],
  ["苦_苦酸_旨_甘_旨_酸_酸_苦塩", "B_3"],
  ["苦_苦酸_旨_甘_旨_酸_酸_旨", "U_4"],
  ["苦_苦酸_旨_甘_旨_酸_酸_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_酸_酸_酸", "B_3"],
  ["苦_苦酸_旨_甘_旨_酸_酸_塩", "B_3"],
  ["苦_苦酸_旨_甘_旨_酸_甘_苦塩", "A_2"],
  ["苦_苦酸_旨_甘_旨_酸_甘_旨", "A_2"],
  ["苦_苦酸_旨_甘_旨_酸_甘_甘", "A_2"],
  ["苦_苦酸_旨_甘_旨_酸_甘_酸", "A_2"],
  ["－_酸甘_塩_旨塩_旨_甘_旨_苦塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_甘_旨_旨", "C_2"],
  ["－_酸甘_塩_旨塩_旨_甘_旨_甘", "C_2"],
  ["－_酸甘_塩_旨塩_旨_甘_旨_酸", "C_2"],
  ["－_酸甘_塩_旨塩_旨_甘_旨_塩", "C_2"],
  ["－_酸甘_塩_旨塩_旨_甘_酸甘_苦塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_甘_酸甘_旨", "C_2"],
  ["－_酸甘_塩_旨塩_旨_甘_酸甘_甘", "A_1"],
  ["－_酸甘_塩_旨塩_旨_甘_酸甘_酸", "U_3"],
  ["－_酸甘_塩_旨塩_旨_甘_酸甘_塩", "C_2"],
  ["－_酸甘_塩_旨塩_旨_甘_苦_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_旨_甘_苦_旨", "A_3"],
  ["－_酸甘_塩_旨塩_旨_甘_苦_甘", "A_3"],
  ["－_酸甘_塩_旨塩_旨_甘_苦_酸", "C_1"],
  ["－_酸甘_塩_旨塩_旨_甘_苦_塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_甘_酸_苦塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_甘_酸_旨", "C_2"],
  ["－_酸甘_塩_旨塩_旨_甘_酸_甘", "C_2"],
  ["－_酸甘_塩_旨塩_旨_甘_酸_酸", "U_3"],
  ["－_酸甘_塩_旨塩_旨_甘_酸_塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_甘_甘_苦塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_甘_甘_旨", "C_2"],
  ["－_酸甘_塩_旨塩_旨_甘_甘_甘", "A_1"],
  ["－_酸甘_塩_旨塩_旨_甘_甘_酸", "C_2"],
  ["－_酸甘_塩_旨塩_旨_甘_甘_塩", "C_2"],
  ["－_酸甘_塩_旨塩_旨_酸_旨_苦塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_酸_旨_旨", "U_4"],
  ["－_酸甘_塩_旨塩_旨_酸_旨_甘", "C_2"],
  ["－_酸甘_塩_旨塩_旨_酸_旨_酸", "C_1"],
  ["－_酸甘_塩_旨塩_旨_酸_旨_塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_酸_酸甘_苦塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_酸_酸甘_旨", "U_3"],
  ["－_酸甘_塩_旨塩_旨_酸_酸甘_甘", "U_3"],
  ["－_酸甘_塩_旨塩_旨_酸_酸甘_酸", "U_3"],
  ["－_酸甘_塩_旨塩_旨_酸_酸甘_塩", "S_3"],
  ["－_酸甘_塩_旨塩_旨_酸_苦_苦塩", "B_1"],
  ["－_酸甘_塩_旨塩_旨_酸_苦_旨", "C_1"],
  ["－_酸甘_塩_旨塩_旨_酸_苦_甘", "C_1"],
  ["－_酸甘_塩_旨塩_旨_酸_苦_酸", "C_1"],
  ["－_酸甘_塩_旨塩_旨_酸_苦_塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_酸_酸_苦塩", "S_1"],
  ["－_酸甘_塩_旨塩_旨_酸_酸_旨", "C_1"],
  ["－_酸甘_塩_旨塩_旨_酸_酸_甘", "U_3"],
  ["－_酸甘_塩_旨塩_旨_酸_酸_酸", "U_3"],
  ["－_酸甘_塩_旨塩_旨_酸_酸_塩", "S_3"],
  ["－_酸甘_塩_旨塩_旨_酸_甘_苦塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_酸_甘_旨", "C_2"],
  ["－_酸甘_塩_旨塩_旨_酸_甘_甘", "C_2"],
  ["－_酸甘_塩_旨塩_旨_酸_甘_酸", "U_3"],
  ["－_酸甘_塩_旨塩_旨_酸_甘_塩", "C_1"],
  ["－_酸甘_塩_甘_苦塩_旨_旨_苦塩", "N_5"],
  ["－_酸甘_塩_甘_苦塩_旨_旨_旨", "A_3"],
  ["－_酸甘_塩_甘_苦塩_旨_旨_甘", "A_3"],
  ["－_酸甘_塩_甘_苦塩_旨_旨_酸", "C_1"],
  ["－_酸甘_塩_甘_苦塩_旨_旨_塩", "C_1"],
  ["－_酸甘_塩_甘_苦塩_旨_酸甘_苦塩", "B_2"],
  ["－_酸甘_塩_甘_苦塩_旨_酸甘_旨", "C_1"],
  ["－_酸甘_塩_甘_苦塩_旨_酸甘_甘", "A_1"],
  ["－_酸甘_塩_甘_苦塩_旨_酸甘_酸", "U_3"],
  ["－_酸甘_塩_甘_苦塩_旨_酸甘_塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_旨_苦_苦塩", "N_5"],
  ["－_酸甘_塩_甘_苦塩_旨_苦_旨", "A_2"],
  ["－_酸甘_塩_甘_苦塩_旨_苦_甘", "B_2"],
  ["－_酸甘_塩_甘_苦塩_旨_苦_酸", "B_2"],
  ["－_酸甘_塩_甘_苦塩_旨_苦_塩", "N_5"],
  ["－_酸甘_塩_甘_苦塩_旨_酸_苦塩", "B_2"],
  ["－_酸甘_塩_甘_苦塩_旨_酸_旨", "C_1"],
  ["－_酸甘_塩_甘_苦塩_旨_酸_甘", "A_1"],
  ["－_酸甘_塩_甘_苦塩_旨_酸_酸", "S_2"],
  ["－_酸甘_塩_甘_苦塩_旨_酸_塩", "S_3"],
  ["－_酸甘_塩_甘_苦塩_旨_甘_苦塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_旨_甘_旨", "A_3"],
  ["－_酸甘_塩_甘_苦塩_旨_甘_甘", "A_1"],
  ["－_酸甘_塩_甘_苦塩_旨_甘_酸", "A_1"],
  ["－_酸甘_塩_甘_苦塩_旨_甘_塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_苦_旨_苦塩", "N_5"],
  ["－_酸甘_塩_甘_苦塩_苦_旨_旨", "A_2"],
  ["－_酸甘_塩_甘_苦塩_苦_旨_甘", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_旨_酸", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_旨_塩", "N_5"],
  ["－_酸甘_塩_甘_苦塩_苦_酸甘_苦塩", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_酸甘_旨", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_酸甘_甘", "C_3"],
  ["－_酸甘_塩_甘_苦塩_苦_酸甘_酸", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_酸甘_塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_苦_苦_苦塩", "N_2"],
  ["－_酸甘_塩_甘_苦塩_苦_苦_旨", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_苦_甘", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_苦_酸", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_苦_塩", "N_5"],
  ["－_酸甘_塩_甘_苦塩_苦_酸_苦塩", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_酸_旨", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_酸_甘", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_酸_酸", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_酸_塩", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_甘_苦塩", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_甘_旨", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_甘_甘", "C_3"],
  ["－_酸甘_塩_甘_苦塩_苦_甘_酸", "B_2"],
  ["－_酸甘_塩_甘_苦塩_苦_甘_塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_塩_旨_苦塩", "N_5"],
  ["－_酸甘_塩_甘_苦塩_塩_旨_旨", "C_1"],
  ["－_酸甘_塩_甘_苦塩_塩_旨_甘", "C_3"],
  ["－_酸甘_塩_甘_苦塩_塩_旨_酸", "S_3"],
  ["－_酸甘_塩_甘_苦塩_塩_旨_塩", "S_3"],
  ["－_酸甘_塩_甘_苦塩_塩_酸甘_苦塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_塩_酸甘_旨", "C_3"],
  ["－_酸甘_塩_甘_苦塩_塩_酸甘_甘", "C_3"],
  ["－_酸甘_塩_甘_苦塩_塩_酸甘_酸", "S_2"],
  ["－_酸甘_塩_甘_苦塩_塩_酸甘_塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_塩_苦_苦塩", "N_5"],
  ["－_酸甘_塩_甘_苦塩_塩_苦_旨", "N_5"],
  ["－_酸甘_塩_甘_苦塩_塩_苦_甘", "C_3"],
  ["－_酸甘_塩_甘_苦塩_塩_苦_酸", "B_2"],
  ["－_酸甘_塩_甘_苦塩_塩_苦_塩", "N_5"],
  ["－_酸甘_塩_甘_苦塩_塩_酸_苦塩", "N_5"],
  ["－_酸甘_塩_甘_苦塩_塩_酸_旨", "S_3"],
  ["－_酸甘_塩_甘_苦塩_塩_酸_甘", "C_3"],
  ["－_酸甘_塩_甘_苦塩_塩_酸_酸", "S_2"],
  ["－_酸甘_塩_甘_苦塩_塩_酸_塩", "S_3"],
  ["－_酸甘_塩_甘_苦塩_塩_甘_苦塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_塩_甘_旨", "C_3"],
  ["－_酸甘_塩_甘_苦塩_塩_甘_甘", "C_3"],
  ["－_酸甘_塩_甘_苦塩_塩_甘_酸", "C_3"],
  ["－_酸甘_塩_甘_苦塩_塩_甘_塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_旨_苦塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_旨_旨", "A_3"],
  ["－_酸甘_塩_甘_苦塩_甘_旨_甘", "A_1"],
  ["－_酸甘_塩_甘_苦塩_甘_旨_酸", "A_1"],
  ["－_酸甘_塩_甘_苦塩_甘_旨_塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_酸甘_苦塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_酸甘_旨", "A_1"],
  ["－_酸甘_塩_甘_苦塩_甘_酸甘_甘", "A_1"],
  ["－_酸甘_塩_甘_苦塩_甘_酸甘_酸", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_酸甘_塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_苦_苦塩", "B_2"],
  ["－_酸甘_塩_甘_苦塩_甘_苦_旨", "B_2"],
  ["－_酸甘_塩_甘_苦塩_甘_苦_甘", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_苦_酸", "B_2"],
  ["－_酸甘_塩_甘_苦塩_甘_苦_塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_酸_苦塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_酸_旨", "A_1"],
  ["－_酸甘_塩_甘_苦塩_甘_酸_甘", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_酸_酸", "S_2"],
  ["－_酸甘_塩_甘_苦塩_甘_酸_塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_甘_苦塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_甘_旨", "A_1"],
  ["－_酸甘_塩_甘_苦塩_甘_甘_甘", "A_1"],
  ["－_酸甘_塩_甘_苦塩_甘_甘_酸", "C_3"],
  ["－_酸甘_塩_甘_苦塩_甘_甘_塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_酸_旨_苦塩", "B_2"],
  ["－_酸甘_塩_甘_苦塩_酸_旨_旨", "C_1"],
  ["－_酸甘_塩_甘_苦塩_酸_旨_甘", "A_1"],
  ["－_酸甘_塩_甘_苦塩_酸_旨_酸", "S_2"],
  ["－_酸甘_塩_甘_苦塩_酸_旨_塩", "S_3"],
  ["－_酸甘_塩_甘_苦塩_酸_酸甘_苦塩", "S_2"],
  ["－_酸甘_塩_甘_苦塩_酸_酸甘_旨", "U_3"],
  ["－_酸甘_塩_甘_苦塩_酸_酸甘_甘", "C_3"],
  ["－_酸甘_塩_甘_苦塩_酸_酸甘_酸", "S_2"],
  ["－_酸甘_塩_甘_苦塩_酸_酸甘_塩", "S_2"],
  ["－_酸甘_塩_甘_苦塩_酸_苦_苦塩", "B_2"],
  ["－_酸甘_塩_甘_苦塩_酸_苦_旨", "B_2"],
  ["－_酸甘_塩_甘_苦塩_酸_苦_甘", "B_2"],
  ["－_酸甘_塩_甘_苦塩_酸_苦_酸", "B_2"],
  ["－_酸甘_塩_甘_苦塩_酸_苦_塩", "B_2"],
  ["－_酸甘_塩_甘_苦塩_酸_酸_苦塩", "S_1"],
  ["－_酸甘_塩_甘_苦塩_酸_酸_旨", "S_2"],
  ["－_酸甘_塩_甘_苦塩_酸_酸_甘", "S_2"],
  ["－_酸甘_塩_甘_苦塩_酸_酸_酸", "S_2"],
  ["－_酸甘_塩_甘_苦塩_酸_酸_塩", "S_2"],
  ["－_酸甘_塩_甘_苦塩_酸_甘_苦塩", "C_3"],
  ["－_酸甘_塩_甘_苦塩_酸_甘_旨", "A_1"],
  ["－_酸甘_塩_甘_苦塩_酸_甘_甘", "C_3"],
  ["－_酸甘_塩_甘_苦塩_酸_甘_酸", "S_2"],
  ["－_酸甘_塩_甘_苦塩_酸_甘_塩", "C_3"],
  ["－_酸甘_塩_甘_旨_旨_旨_苦塩", "A_3"],
  ["－_酸甘_塩_甘_旨_旨_旨_旨", "U_2"],
  ["－_酸甘_塩_甘_旨_旨_旨_甘", "A_3"],
  ["－_酸甘_塩_甘_旨_旨_旨_酸", "U_2"],
  ["－_酸甘_塩_甘_旨_旨_旨_塩", "C_2"],
  ["－_酸甘_塩_甘_旨_旨_酸甘_苦塩", "C_1"],
  ["－_酸甘_塩_甘_旨_旨_酸甘_旨", "U_2"],
  ["－_酸甘_塩_甘_旨_旨_酸甘_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_旨_酸甘_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_旨_酸甘_塩", "C_2"],
  ["－_酸甘_塩_甘_旨_旨_苦_苦塩", "A_2"],
  ["－_酸甘_塩_甘_旨_旨_苦_旨", "A_3"],
  ["－_酸甘_塩_甘_旨_旨_苦_甘", "A_3"],
  ["－_酸甘_塩_甘_旨_旨_苦_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_旨_苦_塩", "C_1"],
  ["－_酸甘_塩_甘_旨_旨_酸_苦塩", "C_1"],
  ["－_酸甘_塩_甘_旨_旨_酸_旨", "U_2"],
  ["－_酸甘_塩_甘_旨_旨_酸_甘", "U_3"],
  ["－_酸甘_塩_甘_旨_旨_酸_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_旨_酸_塩", "C_1"],
  ["－_酸甘_塩_甘_旨_旨_甘_苦塩", "A_3"],
  ["－_酸甘_塩_甘_旨_旨_甘_旨", "A_3"],
  ["－_酸甘_塩_甘_旨_旨_甘_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_旨_甘_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_旨_甘_塩", "C_2"],
  ["－_酸甘_塩_甘_旨_苦_旨_苦塩", "A_2"],
  ["－_酸甘_塩_甘_旨_苦_旨_旨", "A_3"],
  ["－_酸甘_塩_甘_旨_苦_旨_甘", "A_3"],
  ["－_酸甘_塩_甘_旨_苦_旨_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_苦_旨_塩", "C_1"],
  ["－_酸甘_塩_甘_旨_苦_酸甘_苦塩", "B_2"],
  ["－_酸甘_塩_甘_旨_苦_酸甘_旨", "U_3"],
  ["－_酸甘_塩_甘_旨_苦_酸甘_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_苦_酸甘_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_苦_酸甘_塩", "A_1"],
  ["－_酸甘_塩_甘_旨_苦_苦_苦塩", "B_2"],
  ["－_酸甘_塩_甘_旨_苦_苦_旨", "A_2"],
  ["－_酸甘_塩_甘_旨_苦_苦_甘", "A_2"],
  ["－_酸甘_塩_甘_旨_苦_苦_酸", "B_2"],
  ["－_酸甘_塩_甘_旨_苦_苦_塩", "B_2"],
  ["－_酸甘_塩_甘_旨_苦_酸_苦塩", "B_2"],
  ["－_酸甘_塩_甘_旨_苦_酸_旨", "U_3"],
  ["－_酸甘_塩_甘_旨_苦_酸_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_苦_酸_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_苦_酸_塩", "C_1"],
  ["－_酸甘_塩_甘_旨_苦_甘_苦塩", "B_2"],
  ["－_酸甘_塩_甘_旨_苦_甘_旨", "A_3"],
  ["－_酸甘_塩_甘_旨_苦_甘_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_苦_甘_酸", "A_1"],
  ["－_酸甘_塩_甘_旨_苦_甘_塩", "A_1"],
  ["－_酸甘_塩_甘_旨_塩_旨_苦塩", "C_1"],
  ["－_酸甘_塩_甘_旨_塩_旨_旨", "C_2"],
  ["－_酸甘_塩_甘_旨_塩_旨_甘", "C_2"],
  ["－_酸甘_塩_甘_旨_塩_旨_酸", "C_1"],
  ["－_酸甘_塩_甘_旨_塩_旨_塩", "C_1"],
  ["－_酸甘_塩_甘_旨_塩_酸甘_苦塩", "C_3"],
  ["－_酸甘_塩_甘_旨_塩_酸甘_旨", "C_2"],
  ["－_酸甘_塩_甘_旨_塩_酸甘_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_塩_酸甘_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_塩_酸甘_塩", "C_3"],
  ["－_酸甘_塩_甘_旨_塩_苦_苦塩", "N_5"],
  ["－_酸甘_塩_甘_旨_塩_苦_旨", "C_1"],
  ["－_酸甘_塩_甘_旨_塩_苦_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_塩_苦_酸", "C_1"],
  ["－_酸甘_塩_甘_旨_塩_苦_塩", "S_3"],
  ["－_酸甘_塩_甘_旨_塩_酸_苦塩", "S_3"],
  ["－_酸甘_塩_甘_旨_塩_酸_旨", "C_1"],
  ["－_酸甘_塩_甘_旨_塩_酸_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_塩_酸_酸", "S_2"],
  ["－_酸甘_塩_甘_旨_塩_酸_塩", "S_3"],
  ["－_酸甘_塩_甘_旨_塩_甘_苦塩", "C_3"],
  ["－_酸甘_塩_甘_旨_塩_甘_旨", "C_2"],
  ["－_酸甘_塩_甘_旨_塩_甘_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_塩_甘_酸", "A_1"],
  ["－_酸甘_塩_甘_旨_塩_甘_塩", "C_3"],
  ["－_酸甘_塩_甘_旨_甘_旨_苦塩", "A_3"],
  ["－_酸甘_塩_甘_旨_甘_旨_旨", "A_3"],
  ["－_酸甘_塩_甘_旨_甘_旨_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_旨_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_甘_旨_塩", "C_2"],
  ["－_酸甘_塩_甘_旨_甘_酸甘_苦塩", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_酸甘_旨", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_酸甘_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_酸甘_酸", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_酸甘_塩", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_苦_苦塩", "B_2"],
  ["－_酸甘_塩_甘_旨_甘_苦_旨", "A_3"],
  ["－_酸甘_塩_甘_旨_甘_苦_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_苦_酸", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_苦_塩", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_酸_苦塩", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_酸_旨", "U_3"],
  ["－_酸甘_塩_甘_旨_甘_酸_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_酸_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_甘_酸_塩", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_甘_苦塩", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_甘_旨", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_甘_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_甘_酸", "A_1"],
  ["－_酸甘_塩_甘_旨_甘_甘_塩", "A_1"],
  ["－_酸甘_塩_甘_旨_酸_旨_苦塩", "C_1"],
  ["－_酸甘_塩_甘_旨_酸_旨_旨", "U_2"],
  ["－_酸甘_塩_甘_旨_酸_旨_甘", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_旨_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_旨_塩", "C_1"],
  ["－_酸甘_塩_甘_旨_酸_酸甘_苦塩", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_酸甘_旨", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_酸甘_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_酸_酸甘_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_酸甘_塩", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_苦_苦塩", "B_2"],
  ["－_酸甘_塩_甘_旨_酸_苦_旨", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_苦_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_酸_苦_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_苦_塩", "C_1"],
  ["－_酸甘_塩_甘_旨_酸_酸_苦塩", "S_2"],
  ["－_酸甘_塩_甘_旨_酸_酸_旨", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_酸_甘", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_酸_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_酸_塩", "S_2"],
  ["－_酸甘_塩_甘_旨_酸_甘_苦塩", "A_1"],
  ["－_酸甘_塩_甘_旨_酸_甘_旨", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_甘_甘", "A_1"],
  ["－_酸甘_塩_甘_旨_酸_甘_酸", "U_3"],
  ["－_酸甘_塩_甘_旨_酸_甘_塩", "A_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_旨_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_旨_旨", "U_4"],
  ["－_酸甘_旨_旨塩_苦塩_旨_旨_甘", "A_3"],
  ["－_酸甘_旨_旨塩_苦塩_旨_旨_酸", "U_4"],
  ["－_酸甘_旨_旨塩_苦塩_旨_旨_塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_酸甘_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_酸甘_旨", "U_2"],
  ["－_酸甘_旨_旨塩_苦塩_旨_酸甘_甘", "A_3"],
  ["－_酸甘_旨_旨塩_苦塩_旨_酸甘_酸", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_酸甘_塩", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_苦_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_苦_旨", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_苦_甘", "U_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_苦_酸", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_苦_塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_酸_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_酸_旨", "U_4"],
  ["－_酸甘_旨_旨塩_苦塩_旨_酸_甘", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_酸_酸", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_酸_塩", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_甘_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_甘_旨", "A_3"],
  ["－_酸甘_旨_旨塩_苦塩_旨_甘_甘", "A_3"],
  ["－_酸甘_旨_旨塩_苦塩_旨_甘_酸", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_旨_甘_塩", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_旨_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_旨_旨", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_旨_甘", "U_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_旨_酸", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_旨_塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_酸甘_苦塩", "N_2"],
  ["－_酸甘_旨_旨塩_苦塩_苦_酸甘_旨", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_酸甘_甘", "C_3"],
  ["－_酸甘_旨_旨塩_苦塩_苦_酸甘_酸", "U_3"],
  ["－_酸甘_旨_旨塩_苦塩_苦_酸甘_塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_苦_苦塩", "N_2"],
  ["－_酸甘_旨_旨塩_苦塩_苦_苦_旨", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_苦_甘", "N_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_苦_酸", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_苦_塩", "N_2"],
  ["－_酸甘_旨_旨塩_苦塩_苦_酸_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_酸_旨", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_酸_甘", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_酸_酸", "S_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_酸_塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_甘_苦塩", "N_2"],
  ["－_酸甘_旨_旨塩_苦塩_苦_甘_旨", "U_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_甘_甘", "A_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_甘_酸", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_苦_甘_塩", "N_5"],
  ["－_酸甘_旨_旨塩_苦塩_塩_旨_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_旨_旨", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_旨_甘", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_旨_酸", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_旨_塩", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_酸甘_苦塩", "N_5"],
  ["－_酸甘_旨_旨塩_苦塩_塩_酸甘_旨", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_酸甘_甘", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_酸甘_酸", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_酸甘_塩", "S_3"],
  ["－_酸甘_旨_旨塩_苦塩_塩_苦_苦塩", "N_5"],
  ["－_酸甘_旨_旨塩_苦塩_塩_苦_旨", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_苦_甘", "N_5"],
  ["－_酸甘_旨_旨塩_苦塩_塩_苦_酸", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_苦_塩", "N_5"],
  ["－_酸甘_旨_旨塩_苦塩_塩_酸_苦塩", "N_5"],
  ["－_酸甘_旨_旨塩_苦塩_塩_酸_旨", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_酸_甘", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_酸_酸", "S_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_酸_塩", "S_3"],
  ["－_酸甘_旨_旨塩_苦塩_塩_甘_苦塩", "N_5"],
  ["－_酸甘_旨_旨塩_苦塩_塩_甘_旨", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_甘_甘", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_甘_酸", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_塩_甘_塩", "S_3"],
  ["－_酸甘_旨_旨塩_苦塩_甘_旨_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_旨_旨", "A_3"],
  ["－_酸甘_旨_旨塩_苦塩_甘_旨_甘", "A_3"],
  ["－_酸甘_旨_旨塩_苦塩_甘_旨_酸", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_旨_塩", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_酸甘_苦塩", "C_3"],
  ["－_酸甘_旨_旨塩_苦塩_甘_酸甘_旨", "A_3"],
  ["－_酸甘_旨_旨塩_苦塩_甘_酸甘_甘", "A_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_酸甘_酸", "U_3"],
  ["－_酸甘_旨_旨塩_苦塩_甘_酸甘_塩", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_苦_苦塩", "N_2"],
  ["－_酸甘_旨_旨塩_苦塩_甘_苦_旨", "U_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_苦_甘", "A_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_苦_酸", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_苦_塩", "N_5"],
  ["－_酸甘_旨_旨塩_苦塩_甘_酸_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_酸_旨", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_酸_甘", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_酸_酸", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_酸_塩", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_甘_苦塩", "C_3"],
  ["－_酸甘_旨_旨塩_苦塩_甘_甘_旨", "A_3"],
  ["－_酸甘_旨_旨塩_苦塩_甘_甘_甘", "A_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_甘_酸", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_甘_甘_塩", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_旨_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_旨_旨", "U_4"],
  ["－_酸甘_旨_旨塩_苦塩_酸_旨_甘", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_旨_酸", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_旨_塩", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_酸甘_苦塩", "S_2"],
  ["－_酸甘_旨_旨塩_苦塩_酸_酸甘_旨", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_酸甘_甘", "U_3"],
  ["－_酸甘_旨_旨塩_苦塩_酸_酸甘_酸", "U_3"],
  ["－_酸甘_旨_旨塩_苦塩_酸_酸甘_塩", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_苦_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_苦_旨", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_苦_甘", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_苦_酸", "S_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_苦_塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_酸_苦塩", "S_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_酸_旨", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_酸_甘", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_酸_酸", "S_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_酸_塩", "S_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_甘_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_甘_旨", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_甘_甘", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_甘_酸", "C_1"],
  ["－_酸甘_旨_旨塩_苦塩_酸_甘_塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_旨_旨_苦塩", "U_4"],
  ["－_酸甘_旨_旨塩_旨_旨_旨_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_旨_甘", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_旨_酸", "U_4"],
  ["－_酸甘_旨_旨塩_旨_旨_旨_塩", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_酸甘_苦塩", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_酸甘_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_酸甘_甘", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_酸甘_酸", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_酸甘_塩", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_苦_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_旨_旨_苦_旨", "U_4"],
  ["－_酸甘_旨_旨塩_旨_旨_苦_甘", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_苦_酸", "U_4"],
  ["－_酸甘_旨_旨塩_旨_旨_苦_塩", "U_4"],
  ["－_酸甘_旨_旨塩_旨_旨_酸_苦塩", "U_4"],
  ["－_酸甘_旨_旨塩_旨_旨_酸_旨", "U_4"],
  ["－_酸甘_旨_旨塩_旨_旨_酸_甘", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_酸_酸", "U_4"],
  ["－_酸甘_旨_旨塩_旨_旨_酸_塩", "U_4"],
  ["－_酸甘_旨_旨塩_旨_旨_甘_苦塩", "A_3"],
  ["－_酸甘_旨_旨塩_旨_旨_甘_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_甘_甘", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_甘_酸", "U_2"],
  ["－_酸甘_旨_旨塩_旨_旨_甘_塩", "C_2"],
  ["－_酸甘_旨_旨塩_旨_苦_旨_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_旨_苦_旨_旨", "U_4"],
  ["－_酸甘_旨_旨塩_旨_苦_旨_甘", "U_2"],
  ["－_酸甘_旨_旨塩_旨_苦_旨_酸", "U_4"],
  ["－_酸甘_旨_旨塩_旨_苦_旨_塩", "U_4"],
  ["－_酸甘_旨_旨塩_旨_苦_酸甘_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_旨_苦_酸甘_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_苦_酸甘_甘", "A_3"],
  ["－_酸甘_旨_旨塩_旨_苦_酸甘_酸", "U_3"],
  ["－_酸甘_旨_旨塩_旨_苦_酸甘_塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_苦_苦_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_旨_苦_苦_旨", "U_1"],
  ["－_酸甘_旨_旨塩_旨_苦_苦_甘", "A_2"],
  ["－_酸甘_旨_旨塩_旨_苦_苦_酸", "B_1"],
  ["－_酸甘_旨_旨塩_旨_苦_苦_塩", "B_1"],
  ["－_酸甘_旨_旨塩_旨_苦_酸_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_旨_苦_酸_旨", "U_4"],
  ["－_酸甘_旨_旨塩_旨_苦_酸_甘", "U_2"],
  ["－_酸甘_旨_旨塩_旨_苦_酸_酸", "U_4"],
  ["－_酸甘_旨_旨塩_旨_苦_酸_塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_苦_甘_苦塩", "U_1"],
  ["－_酸甘_旨_旨塩_旨_苦_甘_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_苦_甘_甘", "A_3"],
  ["－_酸甘_旨_旨塩_旨_苦_甘_酸", "U_2"],
  ["－_酸甘_旨_旨塩_旨_苦_甘_塩", "A_3"],
  ["－_酸甘_旨_旨塩_旨_塩_旨_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_旨_塩_旨_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_塩_旨_甘", "C_2"],
  ["－_酸甘_旨_旨塩_旨_塩_旨_酸", "U_4"],
  ["－_酸甘_旨_旨塩_旨_塩_旨_塩", "C_2"],
  ["－_酸甘_旨_旨塩_旨_塩_酸甘_苦塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_塩_酸甘_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_塩_酸甘_甘", "C_2"],
  ["－_酸甘_旨_旨塩_旨_塩_酸甘_酸", "U_3"],
  ["－_酸甘_旨_旨塩_旨_塩_酸甘_塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_塩_苦_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_旨_塩_苦_旨", "U_4"],
  ["－_酸甘_旨_旨塩_旨_塩_苦_甘", "A_3"],
  ["－_酸甘_旨_旨塩_旨_塩_苦_酸", "C_1"],
  ["－_酸甘_旨_旨塩_旨_塩_苦_塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_塩_酸_苦塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_塩_酸_旨", "U_4"],
  ["－_酸甘_旨_旨塩_旨_塩_酸_甘", "C_2"],
  ["－_酸甘_旨_旨塩_旨_塩_酸_酸", "C_1"],
  ["－_酸甘_旨_旨塩_旨_塩_酸_塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_塩_甘_苦塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_塩_甘_旨", "C_2"],
  ["－_酸甘_旨_旨塩_旨_塩_甘_甘", "C_2"],
  ["－_酸甘_旨_旨塩_旨_塩_甘_酸", "C_2"],
  ["－_酸甘_旨_旨塩_旨_塩_甘_塩", "C_2"],
  ["－_酸甘_旨_旨塩_旨_甘_旨_苦塩", "A_3"],
  ["－_酸甘_旨_旨塩_旨_甘_旨_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_甘_旨_甘", "U_2"],
  ["－_酸甘_旨_旨塩_旨_甘_旨_酸", "U_2"],
  ["－_酸甘_旨_旨塩_旨_甘_旨_塩", "C_2"],
  ["－_酸甘_旨_旨塩_旨_甘_酸甘_苦塩", "A_3"],
  ["－_酸甘_旨_旨塩_旨_甘_酸甘_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_甘_酸甘_甘", "A_3"],
  ["－_酸甘_旨_旨塩_旨_甘_酸甘_酸", "U_3"],
  ["－_酸甘_旨_旨塩_旨_甘_酸甘_塩", "C_2"],
  ["－_酸甘_旨_旨塩_旨_甘_苦_苦塩", "U_1"],
  ["－_酸甘_旨_旨塩_旨_甘_苦_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_甘_苦_甘", "A_3"],
  ["－_酸甘_旨_旨塩_旨_甘_苦_酸", "U_2"],
  ["－_酸甘_旨_旨塩_旨_甘_苦_塩", "A_3"],
  ["－_酸甘_旨_旨塩_旨_甘_酸_苦塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_甘_酸_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_甘_酸_甘", "U_2"],
  ["－_酸甘_旨_旨塩_旨_甘_酸_酸", "U_3"],
  ["－_酸甘_旨_旨塩_旨_甘_酸_塩", "C_2"],
  ["－_酸甘_旨_旨塩_旨_甘_甘_苦塩", "A_3"],
  ["－_酸甘_旨_旨塩_旨_甘_甘_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_甘_甘_甘", "A_3"],
  ["－_酸甘_旨_旨塩_旨_甘_甘_酸", "U_2"],
  ["－_酸甘_旨_旨塩_旨_甘_甘_塩", "C_2"],
  ["－_酸甘_旨_旨塩_旨_酸_旨_苦塩", "U_4"],
  ["－_酸甘_旨_旨塩_旨_酸_旨_旨", "U_4"],
  ["－_酸甘_旨_旨塩_旨_酸_旨_甘", "U_2"],
  ["－_酸甘_旨_旨塩_旨_酸_旨_酸", "U_4"],
  ["－_酸甘_旨_旨塩_旨_酸_旨_塩", "U_4"],
  ["－_酸甘_旨_旨塩_旨_酸_酸甘_苦塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_酸_酸甘_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_酸_酸甘_甘", "U_3"],
  ["－_酸甘_旨_旨塩_旨_酸_酸甘_酸", "U_3"],
  ["－_酸甘_旨_旨塩_旨_酸_酸甘_塩", "U_3"],
  ["－_酸甘_旨_旨塩_旨_酸_苦_苦塩", "B_1"],
  ["－_酸甘_旨_旨塩_旨_酸_苦_旨", "U_4"],
  ["－_酸甘_旨_旨塩_旨_酸_苦_甘", "U_2"],
  ["－_酸甘_旨_旨塩_旨_酸_苦_酸", "U_4"],
  ["－_酸甘_旨_旨塩_旨_酸_苦_塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_酸_酸_苦塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_酸_酸_旨", "U_4"],
  ["－_酸甘_旨_旨塩_旨_酸_酸_甘", "U_3"],
  ["－_酸甘_旨_旨塩_旨_酸_酸_酸", "U_3"],
  ["－_酸甘_旨_旨塩_旨_酸_酸_塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_酸_甘_苦塩", "C_1"],
  ["－_酸甘_旨_旨塩_旨_酸_甘_旨", "U_2"],
  ["－_酸甘_旨_旨塩_旨_酸_甘_甘", "U_2"],
  ["－_酸甘_旨_旨塩_旨_酸_甘_酸", "U_3"],
  ["－_酸甘_旨_旨塩_旨_酸_甘_塩", "C_2"],
  ["－_酸甘_旨_甘_苦塩_旨_旨_苦塩", "U_1"],
  ["－_酸甘_旨_甘_苦塩_旨_旨_旨", "U_2"],
  ["－_酸甘_旨_甘_苦塩_旨_旨_甘", "A_3"],
  ["－_酸甘_旨_甘_苦塩_旨_旨_酸", "U_2"],
  ["－_酸甘_旨_甘_苦塩_旨_旨_塩", "A_3"],
  ["－_酸甘_旨_甘_苦塩_旨_酸甘_苦塩", "C_2"],
  ["－_酸甘_旨_甘_苦塩_旨_酸甘_旨", "A_3"],
  ["－_酸甘_旨_甘_苦塩_旨_酸甘_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_旨_酸甘_酸", "U_3"],
  ["－_酸甘_旨_甘_苦塩_旨_酸甘_塩", "C_1"],
  ["－_酸甘_旨_甘_苦塩_旨_苦_苦塩", "N_1"],
  ["－_酸甘_旨_甘_苦塩_旨_苦_旨", "A_2"],
  ["－_酸甘_旨_甘_苦塩_旨_苦_甘", "A_2"],
  ["－_酸甘_旨_甘_苦塩_旨_苦_酸", "A_2"],
  ["－_酸甘_旨_甘_苦塩_旨_苦_塩", "A_2"],
  ["－_酸甘_旨_甘_苦塩_旨_酸_苦塩", "B_1"],
  ["－_酸甘_旨_甘_苦塩_旨_酸_旨", "U_2"],
  ["－_酸甘_旨_甘_苦塩_旨_酸_甘", "U_3"],
  ["－_酸甘_旨_甘_苦塩_旨_酸_酸", "U_3"],
  ["－_酸甘_旨_甘_苦塩_旨_酸_塩", "C_1"],
  ["－_酸甘_旨_甘_苦塩_旨_甘_苦塩", "A_1"],
  ["－_酸甘_旨_甘_苦塩_旨_甘_旨", "A_3"],
  ["－_酸甘_旨_甘_苦塩_旨_甘_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_旨_甘_酸", "U_3"],
  ["－_酸甘_旨_甘_苦塩_旨_甘_塩", "A_3"],
  ["－_酸甘_旨_甘_苦塩_苦_旨_苦塩", "N_1"],
  ["－_酸甘_旨_甘_苦塩_苦_旨_旨", "A_2"],
  ["－_酸甘_旨_甘_苦塩_苦_旨_甘", "A_2"],
  ["－_酸甘_旨_甘_苦塩_苦_旨_酸", "A_2"],
  ["－_酸甘_旨_甘_苦塩_苦_旨_塩", "A_2"],
  ["－_酸甘_旨_甘_苦塩_苦_酸甘_苦塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_苦_酸甘_旨", "A_2"],
  ["－_酸甘_旨_甘_苦塩_苦_酸甘_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_苦_酸甘_酸", "B_2"],
  ["－_酸甘_旨_甘_苦塩_苦_酸甘_塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_苦_苦_苦塩", "N_2"],
  ["－_酸甘_旨_甘_苦塩_苦_苦_旨", "A_2"],
  ["－_酸甘_旨_甘_苦塩_苦_苦_甘", "A_2"],
  ["－_酸甘_旨_甘_苦塩_苦_苦_酸", "B_2"],
  ["－_酸甘_旨_甘_苦塩_苦_苦_塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_苦_酸_苦塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_苦_酸_旨", "A_2"],
  ["－_酸甘_旨_甘_苦塩_苦_酸_甘", "A_2"],
  ["－_酸甘_旨_甘_苦塩_苦_酸_酸", "B_2"],
  ["－_酸甘_旨_甘_苦塩_苦_酸_塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_苦_甘_苦塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_苦_甘_旨", "A_2"],
  ["－_酸甘_旨_甘_苦塩_苦_甘_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_苦_甘_酸", "A_2"],
  ["－_酸甘_旨_甘_苦塩_苦_甘_塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_塩_旨_苦塩", "N_5"],
  ["－_酸甘_旨_甘_苦塩_塩_旨_旨", "A_3"],
  ["－_酸甘_旨_甘_苦塩_塩_旨_甘", "A_3"],
  ["－_酸甘_旨_甘_苦塩_塩_旨_酸", "C_1"],
  ["－_酸甘_旨_甘_苦塩_塩_旨_塩", "C_1"],
  ["－_酸甘_旨_甘_苦塩_塩_酸甘_苦塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_塩_酸甘_旨", "C_1"],
  ["－_酸甘_旨_甘_苦塩_塩_酸甘_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_塩_酸甘_酸", "U_3"],
  ["－_酸甘_旨_甘_苦塩_塩_酸甘_塩", "C_3"],
  ["－_酸甘_旨_甘_苦塩_塩_苦_苦塩", "N_5"],
  ["－_酸甘_旨_甘_苦塩_塩_苦_旨", "A_2"],
  ["－_酸甘_旨_甘_苦塩_塩_苦_甘", "B_2"],
  ["－_酸甘_旨_甘_苦塩_塩_苦_酸", "B_2"],
  ["－_酸甘_旨_甘_苦塩_塩_苦_塩", "N_5"],
  ["－_酸甘_旨_甘_苦塩_塩_酸_苦塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_塩_酸_旨", "C_1"],
  ["－_酸甘_旨_甘_苦塩_塩_酸_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_塩_酸_酸", "S_2"],
  ["－_酸甘_旨_甘_苦塩_塩_酸_塩", "S_3"],
  ["－_酸甘_旨_甘_苦塩_塩_甘_苦塩", "C_3"],
  ["－_酸甘_旨_甘_苦塩_塩_甘_旨", "A_3"],
  ["－_酸甘_旨_甘_苦塩_塩_甘_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_塩_甘_酸", "A_1"],
  ["－_酸甘_旨_甘_苦塩_塩_甘_塩", "C_3"],
  ["－_酸甘_旨_甘_苦塩_甘_旨_苦塩", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_旨_旨", "A_3"],
  ["－_酸甘_旨_甘_苦塩_甘_旨_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_旨_酸", "U_3"],
  ["－_酸甘_旨_甘_苦塩_甘_旨_塩", "A_3"],
  ["－_酸甘_旨_甘_苦塩_甘_酸甘_苦塩", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_酸甘_旨", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_酸甘_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_酸甘_酸", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_酸甘_塩", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_苦_苦塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_甘_苦_旨", "A_2"],
  ["－_酸甘_旨_甘_苦塩_甘_苦_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_苦_酸", "A_2"],
  ["－_酸甘_旨_甘_苦塩_甘_苦_塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_甘_酸_苦塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_甘_酸_旨", "U_3"],
  ["－_酸甘_旨_甘_苦塩_甘_酸_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_酸_酸", "U_3"],
  ["－_酸甘_旨_甘_苦塩_甘_酸_塩", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_甘_苦塩", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_甘_旨", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_甘_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_甘_酸", "A_1"],
  ["－_酸甘_旨_甘_苦塩_甘_甘_塩", "A_1"],
  ["－_酸甘_旨_甘_苦塩_酸_旨_苦塩", "B_1"],
  ["－_酸甘_旨_甘_苦塩_酸_旨_旨", "U_2"],
  ["－_酸甘_旨_甘_苦塩_酸_旨_甘", "U_3"],
  ["－_酸甘_旨_甘_苦塩_酸_旨_酸", "U_3"],
  ["－_酸甘_旨_甘_苦塩_酸_旨_塩", "C_1"],
  ["－_酸甘_旨_甘_苦塩_酸_酸甘_苦塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_酸_酸甘_旨", "U_3"],
  ["－_酸甘_旨_甘_苦塩_酸_酸甘_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_酸_酸甘_酸", "U_3"],
  ["－_酸甘_旨_甘_苦塩_酸_酸甘_塩", "U_3"],
  ["－_酸甘_旨_甘_苦塩_酸_苦_苦塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_酸_苦_旨", "A_2"],
  ["－_酸甘_旨_甘_苦塩_酸_苦_甘", "A_2"],
  ["－_酸甘_旨_甘_苦塩_酸_苦_酸", "B_2"],
  ["－_酸甘_旨_甘_苦塩_酸_苦_塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_酸_酸_苦塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_酸_酸_旨", "U_3"],
  ["－_酸甘_旨_甘_苦塩_酸_酸_甘", "U_3"],
  ["－_酸甘_旨_甘_苦塩_酸_酸_酸", "U_3"],
  ["－_酸甘_旨_甘_苦塩_酸_酸_塩", "S_2"],
  ["－_酸甘_旨_甘_苦塩_酸_甘_苦塩", "B_2"],
  ["－_酸甘_旨_甘_苦塩_酸_甘_旨", "U_3"],
  ["－_酸甘_旨_甘_苦塩_酸_甘_甘", "A_1"],
  ["－_酸甘_旨_甘_苦塩_酸_甘_酸", "U_3"],
  ["－_酸甘_旨_甘_苦塩_酸_甘_塩", "A_1"],
  ["－_酸甘_旨_甘_旨_旨_旨_苦塩", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_旨_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_旨_甘", "A_4"],
  ["－_酸甘_旨_甘_旨_旨_旨_酸", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_旨_塩", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_酸甘_苦塩", "A_3"],
  ["－_酸甘_旨_甘_旨_旨_酸甘_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_酸甘_甘", "A_4"],
  ["－_酸甘_旨_甘_旨_旨_酸甘_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_旨_酸甘_塩", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_苦_苦塩", "A_2"],
  ["－_酸甘_旨_甘_旨_旨_苦_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_苦_甘", "A_4"],
  ["－_酸甘_旨_甘_旨_旨_苦_酸", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_苦_塩", "A_3"],
  ["－_酸甘_旨_甘_旨_旨_酸_苦塩", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_酸_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_酸_甘", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_酸_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_旨_酸_塩", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_甘_苦塩", "A_3"],
  ["－_酸甘_旨_甘_旨_旨_甘_旨", "A_4"],
  ["－_酸甘_旨_甘_旨_旨_甘_甘", "A_4"],
  ["－_酸甘_旨_甘_旨_旨_甘_酸", "U_2"],
  ["－_酸甘_旨_甘_旨_旨_甘_塩", "A_3"],
  ["－_酸甘_旨_甘_旨_苦_旨_苦塩", "A_2"],
  ["－_酸甘_旨_甘_旨_苦_旨_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_苦_旨_甘", "A_4"],
  ["－_酸甘_旨_甘_旨_苦_旨_酸", "U_2"],
  ["－_酸甘_旨_甘_旨_苦_旨_塩", "A_3"],
  ["－_酸甘_旨_甘_旨_苦_酸甘_苦塩", "A_2"],
  ["－_酸甘_旨_甘_旨_苦_酸甘_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_苦_酸甘_甘", "A_1"],
  ["－_酸甘_旨_甘_旨_苦_酸甘_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_苦_酸甘_塩", "U_3"],
  ["－_酸甘_旨_甘_旨_苦_苦_苦塩", "A_2"],
  ["－_酸甘_旨_甘_旨_苦_苦_旨", "A_2"],
  ["－_酸甘_旨_甘_旨_苦_苦_甘", "A_2"],
  ["－_酸甘_旨_甘_旨_苦_苦_酸", "A_2"],
  ["－_酸甘_旨_甘_旨_苦_苦_塩", "A_2"],
  ["－_酸甘_旨_甘_旨_苦_酸_苦塩", "A_2"],
  ["－_酸甘_旨_甘_旨_苦_酸_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_苦_酸_甘", "U_3"],
  ["－_酸甘_旨_甘_旨_苦_酸_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_苦_酸_塩", "U_3"],
  ["－_酸甘_旨_甘_旨_苦_甘_苦塩", "A_2"],
  ["－_酸甘_旨_甘_旨_苦_甘_旨", "A_4"],
  ["－_酸甘_旨_甘_旨_苦_甘_甘", "A_1"],
  ["－_酸甘_旨_甘_旨_苦_甘_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_苦_甘_塩", "A_3"],
  ["－_酸甘_旨_甘_旨_塩_旨_苦塩", "A_3"],
  ["－_酸甘_旨_甘_旨_塩_旨_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_塩_旨_甘", "A_3"],
  ["－_酸甘_旨_甘_旨_塩_旨_酸", "U_2"],
  ["－_酸甘_旨_甘_旨_塩_旨_塩", "C_2"],
  ["－_酸甘_旨_甘_旨_塩_酸甘_苦塩", "C_1"],
  ["－_酸甘_旨_甘_旨_塩_酸甘_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_塩_酸甘_甘", "A_1"],
  ["－_酸甘_旨_甘_旨_塩_酸甘_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_塩_酸甘_塩", "C_2"],
  ["－_酸甘_旨_甘_旨_塩_苦_苦塩", "A_2"],
  ["－_酸甘_旨_甘_旨_塩_苦_旨", "A_3"],
  ["－_酸甘_旨_甘_旨_塩_苦_甘", "A_3"],
  ["－_酸甘_旨_甘_旨_塩_苦_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_塩_苦_塩", "C_1"],
  ["－_酸甘_旨_甘_旨_塩_酸_苦塩", "C_1"],
  ["－_酸甘_旨_甘_旨_塩_酸_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_塩_酸_甘", "U_3"],
  ["－_酸甘_旨_甘_旨_塩_酸_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_塩_酸_塩", "C_1"],
  ["－_酸甘_旨_甘_旨_塩_甘_苦塩", "A_3"],
  ["－_酸甘_旨_甘_旨_塩_甘_旨", "A_3"],
  ["－_酸甘_旨_甘_旨_塩_甘_甘", "A_1"],
  ["－_酸甘_旨_甘_旨_塩_甘_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_塩_甘_塩", "C_2"],
  ["－_酸甘_旨_甘_旨_甘_旨_苦塩", "A_3"],
  ["－_酸甘_旨_甘_旨_甘_旨_旨", "A_4"],
  ["－_酸甘_旨_甘_旨_甘_旨_甘", "A_4"],
  ["－_酸甘_旨_甘_旨_甘_旨_酸", "U_2"],
  ["－_酸甘_旨_甘_旨_甘_旨_塩", "A_3"],
  ["－_酸甘_旨_甘_旨_甘_酸甘_苦塩", "A_1"],
  ["－_酸甘_旨_甘_旨_甘_酸甘_旨", "A_4"],
  ["－_酸甘_旨_甘_旨_甘_酸甘_甘", "A_1"],
  ["－_酸甘_旨_甘_旨_甘_酸甘_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_甘_酸甘_塩", "A_1"],
  ["－_酸甘_旨_甘_旨_甘_苦_苦塩", "A_2"],
  ["－_酸甘_旨_甘_旨_甘_苦_旨", "A_4"],
  ["－_酸甘_旨_甘_旨_甘_苦_甘", "A_1"],
  ["－_酸甘_旨_甘_旨_甘_苦_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_甘_苦_塩", "A_3"],
  ["－_酸甘_旨_甘_旨_甘_酸_苦塩", "U_3"],
  ["－_酸甘_旨_甘_旨_甘_酸_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_甘_酸_甘", "A_1"],
  ["－_酸甘_旨_甘_旨_甘_酸_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_甘_酸_塩", "U_3"],
  ["－_酸甘_旨_甘_旨_甘_甘_苦塩", "A_1"],
  ["－_酸甘_旨_甘_旨_甘_甘_旨", "A_4"],
  ["－_酸甘_旨_甘_旨_甘_甘_甘", "A_1"],
  ["－_酸甘_旨_甘_旨_甘_甘_酸", "A_1"],
  ["－_酸甘_旨_甘_旨_甘_甘_塩", "A_1"],
  ["－_酸甘_旨_甘_旨_酸_旨_苦塩", "U_2"],
  ["－_酸甘_旨_甘_旨_酸_旨_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_酸_旨_甘", "U_2"],
  ["－_酸甘_旨_甘_旨_酸_旨_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_旨_塩", "U_2"],
  ["－_酸甘_旨_甘_旨_酸_酸甘_苦塩", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_酸甘_旨", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_酸甘_甘", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_酸甘_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_酸甘_塩", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_苦_苦塩", "A_2"],
  ["－_酸甘_旨_甘_旨_酸_苦_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_酸_苦_甘", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_苦_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_苦_塩", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_酸_苦塩", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_酸_旨", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_酸_甘", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_酸_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_酸_塩", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_甘_苦塩", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_甘_旨", "U_2"],
  ["－_酸甘_旨_甘_旨_酸_甘_甘", "A_1"],
  ["－_酸甘_旨_甘_旨_酸_甘_酸", "U_3"],
  ["－_酸甘_旨_甘_旨_酸_甘_塩", "U_3"],
  ["－_酸甘_塩_旨塩_苦塩_旨_旨_苦塩", "B_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_旨_旨", "B_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_旨_甘", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_旨_酸", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_旨_塩", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_酸甘_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_旨_酸甘_旨", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_酸甘_甘", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_酸甘_酸", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_酸甘_塩", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_旨_苦_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_旨_苦_旨", "B_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_苦_甘", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_旨_苦_酸", "B_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_苦_塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_旨_酸_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_旨_酸_旨", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_酸_甘", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_酸_酸", "S_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_酸_塩", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_旨_甘_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_旨_甘_旨", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_甘_甘", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_甘_酸", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_旨_甘_塩", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_苦_旨_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_苦_旨_旨", "B_1"],
  ["－_酸甘_塩_旨塩_苦塩_苦_旨_甘", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_苦_旨_酸", "B_1"],
  ["－_酸甘_塩_旨塩_苦塩_苦_旨_塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_苦_酸甘_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_苦_酸甘_旨", "B_1"],
  ["－_酸甘_塩_旨塩_苦塩_苦_酸甘_甘", "B_2"],
  ["－_酸甘_塩_旨塩_苦塩_苦_酸甘_酸", "S_1"],
  ["－_酸甘_塩_旨塩_苦塩_苦_酸甘_塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_苦_苦_苦塩", "N_2"],
  ["－_酸甘_塩_旨塩_苦塩_苦_苦_旨", "N_2"],
  ["－_酸甘_塩_旨塩_苦塩_苦_苦_甘", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_苦_苦_酸", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_苦_苦_塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_苦_酸_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_苦_酸_旨", "B_1"],
  ["－_酸甘_塩_旨塩_苦塩_苦_酸_甘", "B_2"],
  ["－_酸甘_塩_旨塩_苦塩_苦_酸_酸", "S_1"],
  ["－_酸甘_塩_旨塩_苦塩_苦_酸_塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_苦_甘_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_苦_甘_旨", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_苦_甘_甘", "C_3"],
  ["－_酸甘_塩_旨塩_苦塩_苦_甘_酸", "B_2"],
  ["－_酸甘_塩_旨塩_苦塩_苦_甘_塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_塩_旨_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_塩_旨_旨", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_塩_旨_甘", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_旨_酸", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_旨_塩", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_酸甘_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_塩_酸甘_旨", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_酸甘_甘", "C_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_酸甘_酸", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_酸甘_塩", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_苦_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_塩_苦_旨", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_塩_苦_甘", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_塩_苦_酸", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_塩_苦_塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_塩_酸_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_塩_酸_旨", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_酸_甘", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_酸_酸", "S_1"],
  ["－_酸甘_塩_旨塩_苦塩_塩_酸_塩", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_甘_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_塩_甘_旨", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_甘_甘", "C_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_甘_酸", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_塩_甘_塩", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_甘_旨_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_甘_旨_旨", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_甘_旨_甘", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_甘_旨_酸", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_甘_旨_塩", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_甘_酸甘_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_甘_酸甘_旨", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_甘_酸甘_甘", "C_3"],
  ["－_酸甘_塩_旨塩_苦塩_甘_酸甘_酸", "S_2"],
  ["－_酸甘_塩_旨塩_苦塩_甘_酸甘_塩", "C_3"],
  ["－_酸甘_塩_旨塩_苦塩_甘_苦_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_甘_苦_旨", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_甘_苦_甘", "C_3"],
  ["－_酸甘_塩_旨塩_苦塩_甘_苦_酸", "B_2"],
  ["－_酸甘_塩_旨塩_苦塩_甘_苦_塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_甘_酸_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_甘_酸_旨", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_甘_酸_甘", "C_3"],
  ["－_酸甘_塩_旨塩_苦塩_甘_酸_酸", "S_2"],
  ["－_酸甘_塩_旨塩_苦塩_甘_酸_塩", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_甘_甘_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_甘_甘_旨", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_甘_甘_甘", "C_3"],
  ["－_酸甘_塩_旨塩_苦塩_甘_甘_酸", "C_3"],
  ["－_酸甘_塩_旨塩_苦塩_甘_甘_塩", "C_3"],
  ["－_酸甘_塩_旨塩_苦塩_酸_旨_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_酸_旨_旨", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_酸_旨_甘", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_酸_旨_酸", "S_1"],
  ["－_酸甘_塩_旨塩_苦塩_酸_旨_塩", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_酸_酸甘_苦塩", "S_1"],
  ["－_酸甘_塩_旨塩_苦塩_酸_酸甘_旨", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_酸_酸甘_甘", "S_2"],
  ["－_酸甘_塩_旨塩_苦塩_酸_酸甘_酸", "S_2"],
  ["－_酸甘_塩_旨塩_苦塩_酸_酸甘_塩", "S_3"],
  ["－_酸甘_塩_旨塩_苦塩_酸_苦_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_酸_苦_旨", "B_1"],
  ["－_酸甘_塩_旨塩_苦塩_酸_苦_甘", "B_2"],
  ["－_酸甘_塩_旨塩_苦塩_酸_苦_酸", "S_1"],
  ["－_酸甘_塩_旨塩_苦塩_酸_苦_塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_酸_酸_苦塩", "S_1"],
  ["－_酸甘_塩_旨塩_苦塩_酸_酸_旨", "S_1"],
  ["－_酸甘_塩_旨塩_苦塩_酸_酸_甘", "S_2"],
  ["－_酸甘_塩_旨塩_苦塩_酸_酸_酸", "S_1"],
  ["－_酸甘_塩_旨塩_苦塩_酸_酸_塩", "S_1"],
  ["－_酸甘_塩_旨塩_苦塩_酸_甘_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_苦塩_酸_甘_旨", "C_1"],
  ["－_酸甘_塩_旨塩_苦塩_酸_甘_甘", "C_3"],
  ["－_酸甘_塩_旨塩_苦塩_酸_甘_酸", "S_2"],
  ["－_酸甘_塩_旨塩_苦塩_酸_甘_塩", "S_3"],
  ["－_酸甘_塩_旨塩_旨_旨_旨_苦塩", "B_1"],
  ["－_酸甘_塩_旨塩_旨_旨_旨_旨", "U_2"],
  ["－_酸甘_塩_旨塩_旨_旨_旨_甘", "C_2"],
  ["－_酸甘_塩_旨塩_旨_旨_旨_酸", "U_4"],
  ["－_酸甘_塩_旨塩_旨_旨_旨_塩", "C_2"],
  ["－_酸甘_塩_旨塩_旨_旨_酸甘_苦塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_旨_酸甘_旨", "U_2"],
  ["－_酸甘_塩_旨塩_旨_旨_酸甘_甘", "C_2"],
  ["－_酸甘_塩_旨塩_旨_旨_酸甘_酸", "U_3"],
  ["－_酸甘_塩_旨塩_旨_旨_酸甘_塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_旨_苦_苦塩", "B_1"],
  ["－_酸甘_塩_旨塩_旨_旨_苦_旨", "U_4"],
  ["－_酸甘_塩_旨塩_旨_旨_苦_甘", "A_3"],
  ["－_酸甘_塩_旨塩_旨_旨_苦_酸", "C_1"],
  ["－_酸甘_塩_旨塩_旨_旨_苦_塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_旨_酸_苦塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_旨_酸_旨", "U_4"],
  ["－_酸甘_塩_旨塩_旨_旨_酸_甘", "C_2"],
  ["－_酸甘_塩_旨塩_旨_旨_酸_酸", "C_1"],
  ["－_酸甘_塩_旨塩_旨_旨_酸_塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_旨_甘_苦塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_旨_甘_旨", "C_2"],
  ["－_酸甘_塩_旨塩_旨_旨_甘_甘", "C_2"],
  ["－_酸甘_塩_旨塩_旨_旨_甘_酸", "C_2"],
  ["－_酸甘_塩_旨塩_旨_旨_甘_塩", "C_2"],
  ["－_酸甘_塩_旨塩_旨_苦_旨_苦塩", "B_1"],
  ["－_酸甘_塩_旨塩_旨_苦_旨_旨", "U_4"],
  ["－_酸甘_塩_旨塩_旨_苦_旨_甘", "A_3"],
  ["－_酸甘_塩_旨塩_旨_苦_旨_酸", "C_1"],
  ["－_酸甘_塩_旨塩_旨_苦_旨_塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_苦_酸甘_苦塩", "B_1"],
  ["－_酸甘_塩_旨塩_旨_苦_酸甘_旨", "C_1"],
  ["－_酸甘_塩_旨塩_旨_苦_酸甘_甘", "C_1"],
  ["－_酸甘_塩_旨塩_旨_苦_酸甘_酸", "C_1"],
  ["－_酸甘_塩_旨塩_旨_苦_酸甘_塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_苦_苦_苦塩", "N_2"],
  ["－_酸甘_塩_旨塩_旨_苦_苦_旨", "B_1"],
  ["－_酸甘_塩_旨塩_旨_苦_苦_甘", "A_2"],
  ["－_酸甘_塩_旨塩_旨_苦_苦_酸", "B_1"],
  ["－_酸甘_塩_旨塩_旨_苦_苦_塩", "B_1"],
  ["－_酸甘_塩_旨塩_旨_苦_酸_苦塩", "B_1"],
  ["－_酸甘_塩_旨塩_旨_苦_酸_旨", "C_1"],
  ["－_酸甘_塩_旨塩_旨_苦_酸_甘", "C_1"],
  ["－_酸甘_塩_旨塩_旨_苦_酸_酸", "C_1"],
  ["－_酸甘_塩_旨塩_旨_苦_酸_塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_苦_甘_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_旨_苦_甘_旨", "A_3"],
  ["－_酸甘_塩_旨塩_旨_苦_甘_甘", "A_3"],
  ["－_酸甘_塩_旨塩_旨_苦_甘_酸", "C_1"],
  ["－_酸甘_塩_旨塩_旨_苦_甘_塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_塩_旨_苦塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_塩_旨_旨", "C_2"],
  ["－_酸甘_塩_旨塩_旨_塩_旨_甘", "C_2"],
  ["－_酸甘_塩_旨塩_旨_塩_旨_酸", "C_1"],
  ["－_酸甘_塩_旨塩_旨_塩_旨_塩", "C_1"],
  ["－_酸甘_塩_旨塩_旨_塩_酸甘_苦塩", "S_3"],
  ["－_酸甘_塩_旨塩_旨_塩_酸甘_旨", "C_1"],
  ["－_酸甘_塩_旨塩_旨_塩_酸甘_甘", "C_2"],
  ["－_酸甘_塩_旨塩_旨_塩_酸甘_酸", "S_3"],
  ["－_酸甘_塩_旨塩_旨_塩_酸甘_塩", "S_3"],
  ["－_酸甘_塩_旨塩_旨_塩_苦_苦塩", "N_5"],
  ["－_酸甘_塩_旨塩_旨_塩_苦_旨", "C_1"],
  ["－_酸甘_塩_旨塩_旨_塩_苦_甘", "C_1"],
  ["－_酸甘_塩_旨塩_旨_塩_苦_酸", "C_1"],
  ["－_酸甘_塩_旨塩_旨_塩_苦_塩", "S_3"],
  ["－_酸甘_塩_旨塩_旨_塩_酸_苦塩", "S_3"],
  ["－_酸甘_塩_旨塩_旨_塩_酸_旨", "C_1"],
  ["－_酸甘_塩_旨塩_旨_塩_酸_甘", "C_1"],
  ["－_酸甘_塩_旨塩_旨_塩_酸_酸", "S_3"],
  ["－_酸甘_塩_旨塩_旨_塩_酸_塩", "S_3"],
  ["－_酸甘_塩_旨塩_旨_塩_甘_苦塩", "S_3"],
  ["－_酸甘_塩_旨塩_旨_塩_甘_旨", "C_2"],
  ["－_酸甘_塩_旨塩_旨_塩_甘_甘", "C_2"],
  ["－_酸甘_塩_旨塩_旨_塩_甘_酸", "C_1"],
  ["－_苦酸_塩_旨塩_旨_塩_甘_塩", "S_3"],
  ["－_苦酸_塩_旨塩_旨_甘_旨_苦塩", "B_1"],
  ["－_苦酸_塩_旨塩_旨_甘_旨_旨", "U_4"],
  ["－_苦酸_塩_旨塩_旨_甘_旨_甘", "A_3"],
  ["－_苦酸_塩_旨塩_旨_甘_旨_酸", "C_1"],
  ["－_苦酸_塩_旨塩_旨_甘_旨_塩", "C_1"],
  ["－_苦酸_塩_旨塩_旨_甘_酸甘_苦塩", "B_1"],
  ["－_苦酸_塩_旨塩_旨_甘_酸甘_旨", "C_1"],
  ["－_苦酸_塩_旨塩_旨_甘_酸甘_甘", "C_1"],
  ["－_苦酸_塩_旨塩_旨_甘_酸甘_酸", "C_1"],
  ["－_苦酸_塩_旨塩_旨_甘_酸甘_塩", "C_1"],
  ["－_苦酸_塩_旨塩_旨_甘_苦_苦塩", "N_2"],
  ["－_苦酸_塩_旨塩_旨_甘_苦_旨", "B_1"],
  ["－_苦酸_塩_旨塩_旨_甘_苦_甘", "A_2"],
  ["－_苦酸_塩_旨塩_旨_甘_苦_酸", "B_1"],
  ["－_苦酸_塩_旨塩_旨_甘_苦_塩", "B_1"],
  ["－_苦酸_塩_旨塩_旨_甘_酸_苦塩", "B_1"],
  ["－_苦酸_塩_旨塩_旨_甘_酸_旨", "C_1"],
  ["－_苦酸_塩_旨塩_旨_甘_酸_甘", "C_1"],
  ["－_苦酸_塩_旨塩_旨_甘_酸_酸", "C_1"],
  ["－_苦酸_塩_旨塩_旨_甘_酸_塩", "C_1"],
  ["－_苦酸_塩_旨塩_旨_甘_甘_苦塩", "N_5"],
  ["－_苦酸_塩_旨塩_旨_甘_甘_旨", "A_3"],
  ["－_苦酸_塩_旨塩_旨_甘_甘_甘", "A_3"],
  ["－_苦酸_塩_旨塩_旨_甘_甘_酸", "C_1"],
  ["－_苦酸_塩_旨塩_旨_甘_甘_塩", "C_1"],
  ["－_苦酸_塩_旨塩_旨_酸_旨_苦塩", "B_1"],
  ["－_苦酸_塩_旨塩_旨_酸_旨_旨", "U_4"],
  ["－_苦酸_塩_旨塩_旨_酸_旨_甘", "C_1"],
  ["－_苦酸_塩_旨塩_旨_酸_旨_酸", "U_4"],
  ["－_苦酸_塩_旨塩_旨_酸_旨_塩", "B_1"],
  ["－_苦酸_塩_旨塩_旨_酸_酸甘_苦塩", "S_1"],
  ["－_苦酸_塩_旨塩_旨_酸_酸甘_旨", "C_1"],
  ["－_苦酸_塩_旨塩_旨_酸_酸甘_甘", "C_1"],
  ["－_苦酸_塩_旨塩_旨_酸_酸甘_酸", "S_1"],
  ["－_苦酸_塩_旨塩_旨_酸_酸甘_塩", "S_1"],
  ["－_苦酸_塩_旨塩_旨_酸_苦_苦塩", "N_4"],
  ["－_苦酸_塩_旨塩_旨_酸_苦_旨", "B_1"],
  ["－_苦酸_塩_旨塩_旨_酸_苦_甘", "B_1"],
  ["－_苦酸_塩_旨塩_旨_酸_苦_酸", "S_1"],
  ["－_苦酸_塩_旨塩_旨_酸_苦_塩", "B_1"],
  ["－_苦酸_塩_旨塩_旨_酸_酸_苦塩", "S_1"],
  ["－_苦酸_塩_旨塩_旨_酸_酸_旨", "U_4"],
  ["－_苦酸_塩_旨塩_旨_酸_酸_甘", "C_1"],
  ["－_苦酸_塩_旨塩_旨_酸_酸_酸", "S_1"],
  ["－_苦酸_塩_旨塩_旨_酸_酸_塩", "S_1"],
  ["－_苦酸_塩_旨塩_旨_酸_甘_苦塩", "B_1"],
  ["－_苦酸_塩_旨塩_旨_酸_甘_旨", "C_1"],
  ["－_苦酸_塩_旨塩_旨_酸_甘_甘", "C_1"],
  ["－_苦酸_塩_旨塩_旨_酸_甘_酸", "C_1"],
  ["－_苦酸_塩_旨塩_旨_酸_甘_塩", "C_1"],
  ["－_苦酸_塩_甘_苦塩_旨_旨_苦塩", "N_2"],
  ["－_苦酸_塩_甘_苦塩_旨_旨_旨", "B_1"],
  ["－_苦酸_塩_甘_苦塩_旨_旨_甘", "A_2"],
  ["－_苦酸_塩_甘_苦塩_旨_旨_酸", "B_1"],
  ["－_苦酸_塩_甘_苦塩_旨_旨_塩", "B_1"],
  ["－_苦酸_塩_甘_苦塩_旨_酸甘_苦塩", "B_2"],
  ["－_苦酸_塩_甘_苦塩_旨_酸甘_旨", "B_1"],
  ["－_苦酸_塩_甘_苦塩_旨_酸甘_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_旨_酸甘_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_旨_酸甘_塩", "B_2"],
  ["－_苦酸_塩_甘_苦塩_旨_苦_苦塩", "N_2"],
  ["－_苦酸_塩_甘_苦塩_旨_苦_旨", "B_1"],
  ["－_苦酸_塩_甘_苦塩_旨_苦_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_旨_苦_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_旨_苦_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_旨_酸_苦塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_旨_酸_旨", "B_1"],
  ["－_苦酸_塩_甘_苦塩_旨_酸_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_旨_酸_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_旨_酸_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_旨_甘_苦塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_旨_甘_旨", "A_2"],
  ["－_苦酸_塩_甘_苦塩_旨_甘_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_旨_甘_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_旨_甘_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_苦_旨_苦塩", "N_2"],
  ["－_苦酸_塩_甘_苦塩_苦_旨_旨", "B_1"],
  ["－_苦酸_塩_甘_苦塩_苦_旨_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_苦_旨_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_苦_旨_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_苦_酸甘_苦塩", "N_3"],
  ["－_苦酸_塩_甘_苦塩_苦_酸甘_旨", "B_2"],
  ["－_苦酸_塩_甘_苦塩_苦_酸甘_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_苦_酸甘_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_苦_酸甘_塩", "B_2"],
  ["－_苦酸_塩_甘_苦塩_苦_苦_苦塩", "N_2"],
  ["－_苦酸_塩_甘_苦塩_苦_苦_旨", "N_2"],
  ["－_苦酸_塩_甘_苦塩_苦_苦_甘", "N_2"],
  ["－_苦酸_塩_甘_苦塩_苦_苦_酸", "N_3"],
  ["－_苦酸_塩_甘_苦塩_苦_苦_塩", "N_2"],
  ["－_苦酸_塩_甘_苦塩_苦_酸_苦塩", "N_3"],
  ["－_苦酸_塩_甘_苦塩_苦_酸_旨", "B_2"],
  ["－_苦酸_塩_甘_苦塩_苦_酸_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_苦_酸_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_苦_酸_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_苦_甘_苦塩", "N_2"],
  ["－_苦酸_塩_甘_苦塩_苦_甘_旨", "B_2"],
  ["－_苦酸_塩_甘_苦塩_苦_甘_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_苦_甘_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_苦_甘_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_旨_苦塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_旨_旨", "B_1"],
  ["－_苦酸_塩_甘_苦塩_塩_旨_甘", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_旨_酸", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_旨_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_酸甘_苦塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_酸甘_旨", "B_2"],
  ["－_苦酸_塩_甘_苦塩_塩_酸甘_甘", "C_3"],
  ["－_苦酸_塩_甘_苦塩_塩_酸甘_酸", "S_1"],
  ["－_苦酸_塩_甘_苦塩_塩_酸甘_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_苦_苦塩", "N_2"],
  ["－_苦酸_塩_甘_苦塩_塩_苦_旨", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_苦_甘", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_苦_酸", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_苦_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_酸_苦塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_酸_旨", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_酸_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_塩_酸_酸", "S_1"],
  ["－_苦酸_塩_甘_苦塩_塩_酸_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_甘_苦塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_甘_旨", "N_5"],
  ["－_苦酸_塩_甘_苦塩_塩_甘_甘", "C_3"],
  ["－_苦酸_塩_甘_苦塩_塩_甘_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_塩_甘_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_甘_旨_苦塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_甘_旨_旨", "A_2"],
  ["－_苦酸_塩_甘_苦塩_甘_旨_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_旨_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_旨_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_甘_酸甘_苦塩", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_酸甘_旨", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_酸甘_甘", "C_3"],
  ["－_苦酸_塩_甘_苦塩_甘_酸甘_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_酸甘_塩", "C_3"],
  ["－_苦酸_塩_甘_苦塩_甘_苦_苦塩", "N_2"],
  ["－_苦酸_塩_甘_苦塩_甘_苦_旨", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_苦_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_苦_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_苦_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_甘_酸_苦塩", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_酸_旨", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_酸_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_酸_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_酸_塩", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_甘_苦塩", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_甘_旨", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_甘_甘", "C_3"],
  ["－_苦酸_塩_甘_苦塩_甘_甘_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_甘_甘_塩", "C_3"],
  ["－_苦酸_塩_甘_苦塩_酸_旨_苦塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_酸_旨_旨", "B_1"],
  ["－_苦酸_塩_甘_苦塩_酸_旨_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_旨_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_旨_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_酸_酸甘_苦塩", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_酸甘_旨", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_酸甘_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_酸甘_酸", "S_2"],
  ["－_苦酸_塩_甘_苦塩_酸_酸甘_塩", "S_1"],
  ["－_苦酸_塩_甘_苦塩_酸_苦_苦塩", "N_3"],
  ["－_苦酸_塩_甘_苦塩_酸_苦_旨", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_苦_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_苦_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_苦_塩", "N_5"],
  ["－_苦酸_塩_甘_苦塩_酸_酸_苦塩", "S_1"],
  ["－_苦酸_塩_甘_苦塩_酸_酸_旨", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_酸_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_酸_酸", "S_1"],
  ["－_苦酸_塩_甘_苦塩_酸_酸_塩", "S_1"],
  ["－_苦酸_塩_甘_苦塩_酸_甘_苦塩", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_甘_旨", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_甘_甘", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_甘_酸", "B_2"],
  ["－_苦酸_塩_甘_苦塩_酸_甘_塩", "B_2"],
  ["－_苦酸_塩_甘_旨_旨_旨_苦塩", "B_1"],
  ["－_苦酸_塩_甘_旨_旨_旨_旨", "U_4"],
  ["－_苦酸_塩_甘_旨_旨_旨_甘", "A_3"],
  ["－_苦酸_塩_甘_旨_旨_旨_酸", "U_4"],
  ["－_苦酸_塩_甘_旨_旨_旨_塩", "C_1"],
  ["－_苦酸_塩_甘_旨_旨_酸甘_苦塩", "B_1"],
  ["－_苦酸_塩_甘_旨_旨_酸甘_旨", "U_2"],
  ["－_苦酸_塩_甘_旨_旨_酸甘_甘", "U_3"],
  ["－_苦酸_塩_甘_旨_旨_酸甘_酸", "U_3"],
  ["－_苦酸_塩_甘_旨_旨_酸甘_塩", "C_1"],
  ["－_苦酸_塩_甘_旨_旨_苦_苦塩", "B_1"],
  ["－_苦酸_塩_甘_旨_旨_苦_旨", "B_1"],
  ["－_苦酸_塩_甘_旨_旨_苦_甘", "A_2"],
  ["－_苦酸_塩_甘_旨_旨_苦_酸", "B_1"],
  ["－_苦酸_塩_甘_旨_旨_苦_塩", "B_1"],
  ["－_苦酸_塩_甘_旨_旨_酸_苦塩", "B_1"],
  ["－_苦酸_塩_甘_旨_旨_酸_旨", "U_4"],
  ["－_苦酸_塩_甘_旨_旨_酸_甘", "U_3"],
  ["－_苦酸_塩_甘_旨_旨_酸_酸", "U_3"],
  ["－_苦酸_塩_甘_旨_旨_酸_塩", "C_1"],
  ["－_苦酸_塩_甘_旨_旨_甘_苦塩", "A_2"],
  ["－_苦酸_塩_甘_旨_旨_甘_旨", "A_3"],
  ["－_苦酸_塩_甘_旨_旨_甘_甘", "A_3"],
  ["－_苦酸_塩_甘_旨_旨_甘_酸", "U_3"],
  ["－_苦酸_塩_甘_旨_旨_甘_塩", "C_1"],
  ["－_苦酸_塩_甘_旨_苦_旨_苦塩", "B_1"],
  ["－_苦酸_塩_甘_旨_苦_旨_旨", "B_1"],
  ["－_苦酸_塩_甘_旨_苦_旨_甘", "A_2"],
  ["－_苦酸_塩_甘_旨_苦_旨_酸", "B_1"],
  ["－_苦酸_塩_甘_旨_苦_旨_塩", "B_1"],
  ["－_苦酸_塩_甘_旨_苦_酸甘_苦塩", "B_2"],
  ["－_苦酸_塩_甘_旨_苦_酸甘_旨", "A_2"],
  ["－_苦酸_塩_甘_旨_苦_酸甘_甘", "A_2"],
  ["－_苦酸_塩_甘_旨_苦_酸甘_酸", "B_2"],
  ["－_苦酸_塩_甘_旨_苦_酸甘_塩", "B_2"],
  ["－_苦酸_塩_甘_旨_苦_苦_苦塩", "N_2"],
  ["－_苦酸_塩_甘_旨_苦_苦_旨", "A_2"],
  ["－_苦酸_塩_甘_旨_苦_苦_甘", "A_2"],
  ["－_苦酸_塩_甘_旨_苦_苦_酸", "B_2"],
  ["－_苦酸_塩_甘_旨_苦_苦_塩", "B_2"],
  ["－_苦酸_塩_甘_旨_苦_酸_苦塩", "B_2"],
  ["－_苦酸_塩_甘_旨_苦_酸_旨", "B_1"],
  ["－_苦酸_塩_甘_旨_苦_酸_甘", "B_2"],
  ["－_苦酸_塩_甘_旨_苦_酸_酸", "B_2"],
  ["－_苦酸_塩_甘_旨_苦_酸_塩", "B_2"],
  ["－_苦酸_塩_甘_旨_苦_甘_苦塩", "B_2"],
  ["－_苦酸_塩_甘_旨_苦_甘_旨", "A_2"],
  ["－_苦酸_塩_甘_旨_苦_甘_甘", "A_2"],
  ["－_苦酸_塩_甘_旨_苦_甘_酸", "B_2"],
  ["－_苦酸_塩_甘_旨_苦_甘_塩", "B_2"],
  ["－_苦酸_塩_甘_旨_塩_旨_苦塩", "B_1"],
  ["－_苦酸_塩_甘_旨_塩_旨_旨", "C_1"],
  ["－_苦酸_塩_甘_旨_塩_旨_甘", "C_1"],
  ["－_苦酸_塩_甘_旨_塩_旨_酸", "C_1"],
  ["－_苦酸_塩_甘_旨_塩_旨_塩", "C_1"],
  ["－_苦酸_塩_甘_旨_塩_酸甘_苦塩", "B_2"],
  ["－_苦酸_塩_甘_旨_塩_酸甘_旨", "C_1"],
  ["－_苦酸_塩_甘_旨_塩_酸甘_甘", "A_1"],
  ["－_苦酸_塩_甘_旨_塩_酸甘_酸", "S_2"],
  ["－_苦酸_塩_甘_旨_塩_酸甘_塩", "S_3"],
  ["－_苦酸_塩_甘_旨_塩_苦_苦塩", "N_5"],
  ["－_苦酸_塩_甘_旨_塩_苦_旨", "B_1"],
  ["－_苦酸_塩_甘_旨_塩_苦_甘", "B_2"],
  ["－_苦酸_塩_甘_旨_塩_苦_酸", "B_2"],
  ["－_苦酸_塩_甘_旨_塩_苦_塩", "N_5"],
  ["－_苦酸_塩_甘_旨_塩_酸_苦塩", "N_5"],
  ["－_苦酸_塩_甘_旨_塩_酸_旨", "C_1"],
  ["－_苦酸_塩_甘_旨_塩_酸_甘", "C_1"],
  ["－_苦酸_塩_甘_旨_塩_酸_酸", "S_1"],
  ["－_苦酸_塩_甘_旨_塩_酸_塩", "S_3"],
  ["－_苦酸_塩_甘_旨_塩_甘_苦塩", "N_5"],
  ["－_苦酸_塩_甘_旨_塩_甘_旨", "C_1"],
  ["－_苦酸_塩_甘_旨_塩_甘_甘", "A_1"],
  ["－_苦酸_塩_甘_旨_塩_甘_酸", "C_1"],
  ["－_苦酸_塩_甘_旨_塩_甘_塩", "S_3"],
  ["－_苦酸_塩_甘_旨_甘_旨_苦塩", "A_2"],
  ["－_苦酸_塩_甘_旨_甘_旨_旨", "A_3"],
  ["－_苦酸_塩_甘_旨_甘_旨_甘", "A_3"],
  ["－_苦酸_塩_甘_旨_甘_旨_酸", "U_3"],
  ["－_苦酸_塩_甘_旨_甘_旨_塩", "C_1"],
  ["－_苦酸_塩_甘_旨_甘_酸甘_苦塩", "B_2"],
  ["－_苦酸_塩_甘_旨_甘_酸甘_旨", "U_3"],
  ["－_苦酸_塩_甘_旨_甘_酸甘_甘", "A_1"],
  ["－_苦酸_塩_甘_旨_甘_酸甘_酸", "U_3"],
  ["－_苦酸_塩_甘_旨_甘_酸甘_塩", "A_1"],
  ["－_苦酸_塩_甘_旨_甘_苦_苦塩", "B_2"],
  ["－_苦酸_塩_甘_旨_甘_苦_旨", "A_2"],
  ["－_苦酸_塩_甘_旨_甘_苦_甘", "A_2"],
  ["－_苦酸_塩_甘_旨_甘_苦_酸", "B_2"],
  ["－_苦酸_塩_甘_旨_甘_苦_塩", "B_2"],
  ["－_苦酸_塩_甘_旨_甘_酸_苦塩", "B_2"],
  ["－_苦酸_塩_甘_旨_甘_酸_旨", "U_3"],
  ["－_苦酸_塩_甘_旨_甘_酸_甘", "A_1"],
  ["－_苦酸_塩_甘_旨_甘_酸_酸", "U_3"],
  ["－_苦酸_塩_甘_旨_甘_酸_塩", "C_1"],
  ["－_苦酸_塩_甘_旨_甘_甘_苦塩", "B_2"],
  ["－_苦酸_塩_甘_旨_甘_甘_旨", "A_3"],
  ["－_苦酸_塩_甘_旨_甘_甘_甘", "A_1"],
  ["－_苦酸_塩_甘_旨_甘_甘_酸", "A_1"],
  ["－_苦酸_塩_甘_旨_甘_甘_塩", "A_1"],
  ["－_苦酸_塩_甘_旨_酸_旨_苦塩", "B_1"],
  ["－_苦酸_塩_甘_旨_酸_旨_旨", "U_4"],
  ["－_苦酸_塩_甘_旨_酸_旨_甘", "U_3"],
  ["－_苦酸_塩_甘_旨_酸_旨_酸", "U_3"],
  ["－_苦酸_塩_甘_旨_酸_旨_塩", "C_1"],
  ["－_苦酸_塩_甘_旨_酸_酸甘_苦塩", "B_2"],
  ["－_苦酸_塩_甘_旨_酸_酸甘_旨", "U_3"],
  ["－_苦酸_塩_甘_旨_酸_酸甘_甘", "U_3"],
  ["－_苦酸_塩_甘_旨_酸_酸甘_酸", "U_3"],
  ["－_苦酸_塩_甘_旨_酸_酸甘_塩", "S_2"],
  ["－_苦酸_塩_甘_旨_酸_苦_苦塩", "B_2"],
  ["－_苦酸_塩_甘_旨_酸_苦_旨", "B_1"],
  ["－_苦酸_塩_甘_旨_酸_苦_甘", "B_2"],
  ["－_苦酸_塩_甘_旨_酸_苦_酸", "B_2"],
  ["－_苦酸_塩_甘_旨_酸_苦_塩", "B_2"],
  ["－_苦酸_塩_甘_旨_酸_酸_苦塩", "B_2"],
  ["－_苦酸_塩_甘_旨_酸_酸_旨", "U_3"],
  ["－_苦酸_塩_甘_旨_酸_酸_甘", "U_3"],
  ["－_苦酸_塩_甘_旨_酸_酸_酸", "U_3"],
  ["－_苦酸_塩_甘_旨_酸_酸_塩", "S_1"],
  ["－_苦酸_塩_甘_旨_酸_甘_苦塩", "B_2"],
  ["－_苦酸_塩_甘_旨_酸_甘_旨", "U_3"],
  ["－_苦酸_塩_甘_旨_酸_甘_甘", "A_1"],
  ["－_苦酸_塩_甘_旨_酸_甘_酸", "U_3"],
  ["－_苦酸_塩_甘_旨_酸_甘_塩", "C_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_旨_苦塩", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_旨_旨", "U_4"],
  ["－_苦酸_旨_旨塩_苦塩_旨_旨_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_旨_酸", "U_4"],
  ["－_苦酸_旨_旨塩_苦塩_旨_旨_塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_酸甘_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_酸甘_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_酸甘_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_酸甘_酸", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_酸甘_塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_苦_苦塩", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_苦_旨", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_苦_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_苦_酸", "B_3"],
  ["－_苦酸_旨_旨塩_苦塩_旨_苦_塩", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_酸_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_酸_旨", "U_4"],
  ["－_苦酸_旨_旨塩_苦塩_旨_酸_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_酸_酸", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_酸_塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_甘_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_甘_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_甘_甘", "U_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_甘_酸", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_旨_甘_塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_旨_苦塩", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_旨_旨", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_旨_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_旨_酸", "B_3"],
  ["－_苦酸_旨_旨塩_苦塩_苦_旨_塩", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_酸甘_苦塩", "N_3"],
  ["－_苦酸_旨_旨塩_苦塩_苦_酸甘_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_酸甘_甘", "N_3"],
  ["－_苦酸_旨_旨塩_苦塩_苦_酸甘_酸", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_酸甘_塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_苦_苦塩", "N_2"],
  ["－_苦酸_旨_旨塩_苦塩_苦_苦_旨", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_苦_甘", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_苦_酸", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_苦_塩", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_酸_苦塩", "N_4"],
  ["－_苦酸_旨_旨塩_苦塩_苦_酸_旨", "B_3"],
  ["－_苦酸_旨_旨塩_苦塩_苦_酸_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_酸_酸", "B_3"],
  ["－_苦酸_旨_旨塩_苦塩_苦_酸_塩", "N_4"],
  ["－_苦酸_旨_旨塩_苦塩_苦_甘_苦塩", "N_2"],
  ["－_苦酸_旨_旨塩_苦塩_苦_甘_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_甘_甘", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_甘_酸", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_苦_甘_塩", "N_2"],
  ["－_苦酸_旨_旨塩_苦塩_塩_旨_苦塩", "N_4"],
  ["－_苦酸_旨_旨塩_苦塩_塩_旨_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_旨_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_旨_酸", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_旨_塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_酸甘_苦塩", "N_5"],
  ["－_苦酸_旨_旨塩_苦塩_塩_酸甘_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_酸甘_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_酸甘_酸", "S_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_酸甘_塩", "N_5"],
  ["－_苦酸_旨_旨塩_苦塩_塩_苦_苦塩", "N_2"],
  ["－_苦酸_旨_旨塩_苦塩_塩_苦_旨", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_苦_甘", "N_2"],
  ["－_苦酸_旨_旨塩_苦塩_塩_苦_酸", "N_4"],
  ["－_苦酸_旨_旨塩_苦塩_塩_苦_塩", "N_5"],
  ["－_苦酸_旨_旨塩_苦塩_塩_酸_苦塩", "N_4"],
  ["－_苦酸_旨_旨塩_苦塩_塩_酸_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_酸_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_酸_酸", "S_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_酸_塩", "N_4"],
  ["－_苦酸_旨_旨塩_苦塩_塩_甘_苦塩", "N_5"],
  ["－_苦酸_旨_旨塩_苦塩_塩_甘_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_甘_甘", "N_5"],
  ["－_苦酸_旨_旨塩_苦塩_塩_甘_酸", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_塩_甘_塩", "N_5"],
  ["－_苦酸_旨_旨塩_苦塩_甘_旨_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_旨_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_旨_甘", "U_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_旨_酸", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_旨_塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_酸甘_苦塩", "N_2"],
  ["－_苦酸_旨_旨塩_苦塩_甘_酸甘_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_酸甘_甘", "C_3"],
  ["－_苦酸_旨_旨塩_苦塩_甘_酸甘_酸", "U_3"],
  ["－_苦酸_旨_旨塩_苦塩_甘_酸甘_塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_苦_苦塩", "N_2"],
  ["－_苦酸_旨_旨塩_苦塩_甘_苦_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_苦_甘", "N_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_苦_酸", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_苦_塩", "N_2"],
  ["－_苦酸_旨_旨塩_苦塩_甘_酸_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_酸_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_酸_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_酸_酸", "S_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_酸_塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_甘_苦塩", "N_5"],
  ["－_苦酸_旨_旨塩_苦塩_甘_甘_旨", "U_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_甘_甘", "A_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_甘_酸", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_甘_甘_塩", "N_5"],
  ["－_苦酸_旨_旨塩_苦塩_酸_旨_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_旨_旨", "U_4"],
  ["－_苦酸_旨_旨塩_苦塩_酸_旨_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_旨_酸", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_旨_塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_酸甘_苦塩", "N_4"],
  ["－_苦酸_旨_旨塩_苦塩_酸_酸甘_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_酸甘_甘", "U_3"],
  ["－_苦酸_旨_旨塩_苦塩_酸_酸甘_酸", "S_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_酸甘_塩", "S_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_苦_苦塩", "N_4"],
  ["－_苦酸_旨_旨塩_苦塩_酸_苦_旨", "B_3"],
  ["－_苦酸_旨_旨塩_苦塩_酸_苦_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_苦_酸", "B_3"],
  ["－_苦酸_旨_旨塩_苦塩_酸_苦_塩", "N_4"],
  ["－_苦酸_旨_旨塩_苦塩_酸_酸_苦塩", "N_4"],
  ["－_苦酸_旨_旨塩_苦塩_酸_酸_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_酸_甘", "S_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_酸_酸", "S_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_酸_塩", "S_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_甘_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_甘_旨", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_甘_甘", "B_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_甘_酸", "S_1"],
  ["－_苦酸_旨_旨塩_苦塩_酸_甘_塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_旨_旨_苦塩", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_旨_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_旨_甘", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_旨_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_旨_塩", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_酸甘_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_旨_酸甘_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_酸甘_甘", "U_2"],
  ["－_苦酸_旨_旨塩_旨_旨_酸甘_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_酸甘_塩", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_苦_苦塩", "N_1"],
  ["－_苦酸_旨_旨塩_旨_旨_苦_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_苦_甘", "U_1"],
  ["－_苦酸_旨_旨塩_旨_旨_苦_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_苦_塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_旨_酸_苦塩", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_酸_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_酸_甘", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_酸_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_酸_塩", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_甘_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_旨_甘_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_甘_甘", "U_2"],
  ["－_苦酸_旨_旨塩_旨_旨_甘_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_旨_甘_塩", "U_4"],
  ["－_苦酸_旨_旨塩_旨_苦_旨_苦塩", "N_1"],
  ["－_苦酸_旨_旨塩_旨_苦_旨_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_苦_旨_甘", "U_1"],
  ["－_苦酸_旨_旨塩_旨_苦_旨_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_苦_旨_塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_苦_酸甘_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_苦_酸甘_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_苦_酸甘_甘", "A_2"],
  ["－_苦酸_旨_旨塩_旨_苦_酸甘_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_苦_酸甘_塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_苦_苦_苦塩", "N_1"],
  ["－_苦酸_旨_旨塩_旨_苦_苦_旨", "U_1"],
  ["－_苦酸_旨_旨塩_旨_苦_苦_甘", "B_3"],
  ["－_苦酸_旨_旨塩_旨_苦_苦_酸", "B_3"],
  ["－_苦酸_旨_旨塩_旨_苦_苦_塩", "N_1"],
  ["－_苦酸_旨_旨塩_旨_苦_酸_苦塩", "B_3"],
  ["－_苦酸_旨_旨塩_旨_苦_酸_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_苦_酸_甘", "B_1"],
  ["－_苦酸_旨_旨塩_旨_苦_酸_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_苦_酸_塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_苦_甘_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_苦_甘_旨", "U_1"],
  ["－_苦酸_旨_旨塩_旨_苦_甘_甘", "A_2"],
  ["－_苦酸_旨_旨塩_旨_苦_甘_酸", "B_1"],
  ["－_苦酸_旨_旨塩_旨_苦_甘_塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_塩_旨_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_塩_旨_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_塩_旨_甘", "U_4"],
  ["－_苦酸_旨_旨塩_旨_塩_旨_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_塩_旨_塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_塩_酸甘_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_塩_酸甘_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_塩_酸甘_甘", "C_1"],
  ["－_苦酸_旨_旨塩_旨_塩_酸甘_酸", "C_1"],
  ["－_苦酸_旨_旨塩_旨_塩_酸甘_塩", "C_1"],
  ["－_苦酸_旨_旨塩_旨_塩_苦_苦塩", "N_1"],
  ["－_苦酸_旨_旨塩_旨_塩_苦_旨", "B_1"],
  ["－_苦酸_旨_旨塩_旨_塩_苦_甘", "B_1"],
  ["－_苦酸_旨_旨塩_旨_塩_苦_酸", "B_1"],
  ["－_苦酸_旨_旨塩_旨_塩_苦_塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_塩_酸_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_塩_酸_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_塩_酸_甘", "C_1"],
  ["－_苦酸_旨_旨塩_旨_塩_酸_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_塩_酸_塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_塩_甘_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_塩_甘_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_塩_甘_甘", "A_3"],
  ["－_苦酸_旨_旨塩_旨_塩_甘_酸", "C_1"],
  ["－_苦酸_旨_旨塩_旨_塩_甘_塩", "C_1"],
  ["－_苦酸_旨_旨塩_旨_甘_旨_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_甘_旨_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_甘_旨_甘", "U_2"],
  ["－_苦酸_旨_旨塩_旨_甘_旨_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_甘_旨_塩", "U_4"],
  ["－_苦酸_旨_旨塩_旨_甘_酸甘_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_甘_酸甘_旨", "U_2"],
  ["－_苦酸_旨_旨塩_旨_甘_酸甘_甘", "A_3"],
  ["－_苦酸_旨_旨塩_旨_甘_酸甘_酸", "U_3"],
  ["－_苦酸_旨_旨塩_旨_甘_酸甘_塩", "C_1"],
  ["－_苦酸_旨_旨塩_旨_甘_苦_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_甘_苦_旨", "U_1"],
  ["－_苦酸_旨_旨塩_旨_甘_苦_甘", "A_2"],
  ["－_苦酸_旨_旨塩_旨_甘_苦_酸", "B_1"],
  ["－_苦酸_旨_旨塩_旨_甘_苦_塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_甘_酸_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_甘_酸_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_甘_酸_甘", "U_2"],
  ["－_苦酸_旨_旨塩_旨_甘_酸_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_甘_酸_塩", "C_1"],
  ["－_苦酸_旨_旨塩_旨_甘_甘_苦塩", "U_1"],
  ["－_苦酸_旨_旨塩_旨_甘_甘_旨", "U_2"],
  ["－_苦酸_旨_旨塩_旨_甘_甘_甘", "A_3"],
  ["－_苦酸_旨_旨塩_旨_甘_甘_酸", "U_2"],
  ["－_苦酸_旨_旨塩_旨_甘_甘_塩", "A_3"],
  ["－_苦酸_旨_旨塩_旨_酸_旨_苦塩", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_旨_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_旨_甘", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_旨_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_旨_塩", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_酸甘_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_酸_酸甘_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_酸甘_甘", "U_3"],
  ["－_苦酸_旨_旨塩_旨_酸_酸甘_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_酸甘_塩", "C_1"],
  ["－_苦酸_旨_旨塩_旨_酸_苦_苦塩", "B_3"],
  ["－_苦酸_旨_旨塩_旨_酸_苦_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_苦_甘", "B_1"],
  ["－_苦酸_旨_旨塩_旨_酸_苦_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_苦_塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_酸_酸_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_酸_酸_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_酸_甘", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_酸_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_酸_塩", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_甘_苦塩", "B_1"],
  ["－_苦酸_旨_旨塩_旨_酸_甘_旨", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_甘_甘", "U_2"],
  ["－_苦酸_旨_旨塩_旨_酸_甘_酸", "U_4"],
  ["－_苦酸_旨_旨塩_旨_酸_甘_塩", "C_1"],
  ["－_苦酸_旨_甘_苦塩_旨_旨_苦塩", "B_1"],
  ["－_苦酸_旨_甘_苦塩_旨_旨_旨", "U_1"],
  ["－_苦酸_旨_甘_苦塩_旨_旨_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_旨_旨_酸", "B_1"],
  ["－_苦酸_旨_甘_苦塩_旨_旨_塩", "B_1"],
  ["－_苦酸_旨_甘_苦塩_旨_酸甘_苦塩", "N_3"],
  ["－_苦酸_旨_甘_苦塩_旨_酸甘_旨", "A_2"],
  ["－_苦酸_旨_甘_苦塩_旨_酸甘_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_旨_酸甘_酸", "U_3"],
  ["－_苦酸_旨_甘_苦塩_旨_酸甘_塩", "B_1"],
  ["－_苦酸_旨_甘_苦塩_旨_苦_苦塩", "N_1"],
  ["－_苦酸_旨_甘_苦塩_旨_苦_旨", "B_3"],
  ["－_苦酸_旨_甘_苦塩_旨_苦_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_旨_苦_酸", "B_3"],
  ["－_苦酸_旨_甘_苦塩_旨_苦_塩", "B_1"],
  ["－_苦酸_旨_甘_苦塩_旨_酸_苦塩", "B_1"],
  ["－_苦酸_旨_甘_苦塩_旨_酸_旨", "B_1"],
  ["－_苦酸_旨_甘_苦塩_旨_酸_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_旨_酸_酸", "B_3"],
  ["－_苦酸_旨_甘_苦塩_旨_酸_塩", "B_1"],
  ["－_苦酸_旨_甘_苦塩_旨_甘_苦塩", "N_1"],
  ["－_苦酸_旨_甘_苦塩_旨_甘_旨", "A_2"],
  ["－_苦酸_旨_甘_苦塩_旨_甘_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_旨_甘_酸", "A_2"],
  ["－_苦酸_旨_甘_苦塩_旨_甘_塩", "A_2"],
  ["－_苦酸_旨_甘_苦塩_苦_旨_苦塩", "N_1"],
  ["－_苦酸_旨_甘_苦塩_苦_旨_旨", "B_3"],
  ["－_苦酸_旨_甘_苦塩_苦_旨_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_苦_旨_酸", "B_3"],
  ["－_苦酸_旨_甘_苦塩_苦_旨_塩", "B_1"],
  ["－_苦酸_旨_甘_苦塩_苦_酸甘_苦塩", "N_3"],
  ["－_苦酸_旨_甘_苦塩_苦_酸甘_旨", "A_2"],
  ["－_苦酸_旨_甘_苦塩_苦_酸甘_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_苦_酸甘_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_苦_酸甘_塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_苦_苦_苦塩", "N_2"],
  ["－_苦酸_旨_甘_苦塩_苦_苦_旨", "N_1"],
  ["－_苦酸_旨_甘_苦塩_苦_苦_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_苦_苦_酸", "N_3"],
  ["－_苦酸_旨_甘_苦塩_苦_苦_塩", "N_2"],
  ["－_苦酸_旨_甘_苦塩_苦_酸_苦塩", "N_3"],
  ["－_苦酸_旨_甘_苦塩_苦_酸_旨", "B_3"],
  ["－_苦酸_旨_甘_苦塩_苦_酸_甘", "B_2"],
  ["－_苦酸_旨_甘_苦塩_苦_酸_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_苦_酸_塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_苦_甘_苦塩", "N_2"],
  ["－_苦酸_旨_甘_苦塩_苦_甘_旨", "A_2"],
  ["－_苦酸_旨_甘_苦塩_苦_甘_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_苦_甘_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_苦_甘_塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_塩_旨_苦塩", "N_2"],
  ["－_苦酸_旨_甘_苦塩_塩_旨_旨", "B_1"],
  ["－_苦酸_旨_甘_苦塩_塩_旨_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_塩_旨_酸", "B_1"],
  ["－_苦酸_旨_甘_苦塩_塩_旨_塩", "B_1"],
  ["－_苦酸_旨_甘_苦塩_塩_酸甘_苦塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_塩_酸甘_旨", "B_1"],
  ["－_苦酸_旨_甘_苦塩_塩_酸甘_甘", "B_2"],
  ["－_苦酸_旨_甘_苦塩_塩_酸甘_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_塩_酸甘_塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_塩_苦_苦塩", "N_2"],
  ["－_苦酸_旨_甘_苦塩_塩_苦_旨", "B_1"],
  ["－_苦酸_旨_甘_苦塩_塩_苦_甘", "B_2"],
  ["－_苦酸_旨_甘_苦塩_塩_苦_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_塩_苦_塩", "N_5"],
  ["－_苦酸_旨_甘_苦塩_塩_酸_苦塩", "N_5"],
  ["－_苦酸_旨_甘_苦塩_塩_酸_旨", "B_1"],
  ["－_苦酸_旨_甘_苦塩_塩_酸_甘", "B_2"],
  ["－_苦酸_旨_甘_苦塩_塩_酸_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_塩_酸_塩", "N_5"],
  ["－_苦酸_旨_甘_苦塩_塩_甘_苦塩", "N_5"],
  ["－_苦酸_旨_甘_苦塩_塩_甘_旨", "A_2"],
  ["－_苦酸_旨_甘_苦塩_塩_甘_甘", "B_2"],
  ["－_苦酸_旨_甘_苦塩_塩_甘_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_塩_甘_塩", "N_5"],
  ["－_苦酸_旨_甘_苦塩_甘_旨_苦塩", "N_1"],
  ["－_苦酸_旨_甘_苦塩_甘_旨_旨", "A_2"],
  ["－_苦酸_旨_甘_苦塩_甘_旨_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_甘_旨_酸", "A_2"],
  ["－_苦酸_旨_甘_苦塩_甘_旨_塩", "A_2"],
  ["－_苦酸_旨_甘_苦塩_甘_酸甘_苦塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_甘_酸甘_旨", "A_2"],
  ["－_苦酸_旨_甘_苦塩_甘_酸甘_甘", "A_1"],
  ["－_苦酸_旨_甘_苦塩_甘_酸甘_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_甘_酸甘_塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_甘_苦_苦塩", "N_2"],
  ["－_苦酸_旨_甘_苦塩_甘_苦_旨", "A_2"],
  ["－_苦酸_旨_甘_苦塩_甘_苦_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_甘_苦_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_甘_苦_塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_甘_酸_苦塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_甘_酸_旨", "A_2"],
  ["－_苦酸_旨_甘_苦塩_甘_酸_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_甘_酸_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_甘_酸_塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_甘_甘_苦塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_甘_甘_旨", "A_2"],
  ["－_苦酸_旨_甘_苦塩_甘_甘_甘", "A_1"],
  ["－_苦酸_旨_甘_苦塩_甘_甘_酸", "A_2"],
  ["－_苦酸_旨_甘_苦塩_甘_甘_塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_旨_苦塩", "B_1"],
  ["－_苦酸_旨_甘_苦塩_酸_旨_旨", "B_1"],
  ["－_苦酸_旨_甘_苦塩_酸_旨_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_酸_旨_酸", "B_3"],
  ["－_苦酸_旨_甘_苦塩_酸_旨_塩", "B_1"],
  ["－_苦酸_旨_甘_苦塩_酸_酸甘_苦塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_酸甘_旨", "U_3"],
  ["－_苦酸_旨_甘_苦塩_酸_酸甘_甘", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_酸甘_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_酸甘_塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_苦_苦塩", "N_3"],
  ["－_苦酸_旨_甘_苦塩_酸_苦_旨", "B_3"],
  ["－_苦酸_旨_甘_苦塩_酸_苦_甘", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_苦_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_苦_塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_酸_苦塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_酸_旨", "B_3"],
  ["－_苦酸_旨_甘_苦塩_酸_酸_甘", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_酸_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_酸_塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_甘_苦塩", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_甘_旨", "A_2"],
  ["－_苦酸_旨_甘_苦塩_酸_甘_甘", "A_2"],
  ["－_苦酸_旨_甘_苦塩_酸_甘_酸", "B_2"],
  ["－_苦酸_旨_甘_苦塩_酸_甘_塩", "B_2"],
  ["－_苦酸_旨_甘_旨_旨_旨_苦塩", "U_1"],
  ["－_苦酸_旨_甘_旨_旨_旨_旨", "U_4"],
  ["－_苦酸_旨_甘_旨_旨_旨_甘", "U_2"],
  ["－_苦酸_旨_甘_旨_旨_旨_酸", "U_4"],
  ["－_苦酸_旨_甘_旨_旨_旨_塩", "U_4"],
  ["－_苦酸_旨_甘_旨_旨_酸甘_苦塩", "A_2"],
  ["－_苦酸_旨_甘_旨_旨_酸甘_旨", "U_2"],
  ["－_苦酸_旨_甘_旨_旨_酸甘_甘", "U_2"],
  ["－_苦酸_旨_甘_旨_旨_酸甘_酸", "U_2"],
  ["－_苦酸_旨_甘_旨_旨_酸甘_塩", "U_2"],
  ["－_苦酸_旨_甘_旨_旨_苦_苦塩", "B_3"],
  ["－_苦酸_旨_甘_旨_旨_苦_旨", "U_1"],
  ["－_苦酸_旨_甘_旨_旨_苦_甘", "A_2"],
  ["－_苦酸_旨_甘_旨_旨_苦_酸", "U_4"],
  ["－_苦酸_旨_甘_旨_旨_苦_塩", "B_1"],
  ["－_苦酸_旨_甘_旨_旨_酸_苦塩", "B_1"],
  ["－_苦酸_旨_甘_旨_旨_酸_旨", "U_4"],
  ["－_苦酸_旨_甘_旨_旨_酸_甘", "U_2"],
  ["－_苦酸_旨_甘_旨_旨_酸_酸", "U_4"],
  ["－_苦酸_旨_甘_旨_旨_酸_塩", "U_4"],
  ["－_苦酸_旨_甘_旨_旨_甘_苦塩", "A_2"],
  ["－_苦酸_旨_甘_旨_旨_甘_旨", "U_2"],
  ["－_苦酸_旨_甘_旨_旨_甘_甘", "A_4"],
  ["－_苦酸_旨_甘_旨_旨_甘_酸", "U_2"],
  ["－_苦酸_旨_甘_旨_旨_甘_塩", "A_3"],
  ["－_苦酸_旨_甘_旨_苦_旨_苦塩", "B_3"],
  ["－_苦酸_旨_甘_旨_苦_旨_旨", "U_1"],
  ["－_苦酸_旨_甘_旨_苦_旨_甘", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_旨_酸", "U_4"],
  ["－_苦酸_旨_甘_旨_苦_旨_塩", "B_1"],
  ["－_苦酸_旨_甘_旨_苦_酸甘_苦塩", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_酸甘_旨", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_酸甘_甘", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_酸甘_酸", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_酸甘_塩", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_苦_苦塩", "N_1"],
  ["－_苦酸_旨_甘_旨_苦_苦_旨", "U_1"],
  ["－_苦酸_旨_甘_旨_苦_苦_甘", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_苦_酸", "B_3"],
  ["－_苦酸_旨_甘_旨_苦_苦_塩", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_酸_苦塩", "B_3"],
  ["－_苦酸_旨_甘_旨_苦_酸_旨", "U_4"],
  ["－_苦酸_旨_甘_旨_苦_酸_甘", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_酸_酸", "B_3"],
  ["－_苦酸_旨_甘_旨_苦_酸_塩", "B_1"],
  ["－_苦酸_旨_甘_旨_苦_甘_苦塩", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_甘_旨", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_甘_甘", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_甘_酸", "A_2"],
  ["－_苦酸_旨_甘_旨_苦_甘_塩", "A_2"],
  ["－_苦酸_旨_甘_旨_塩_旨_苦塩", "B_1"],
  ["－_苦酸_旨_甘_旨_塩_旨_旨", "U_4"],
  ["－_苦酸_旨_甘_旨_塩_旨_甘", "A_3"],
  ["－_苦酸_旨_甘_旨_塩_旨_酸", "U_4"],
  ["－_苦酸_旨_甘_旨_塩_旨_塩", "C_1"],
  ["－_苦酸_旨_甘_旨_塩_酸甘_苦塩", "B_1"],
  ["－_苦酸_旨_甘_旨_塩_酸甘_旨", "U_2"],
  ["－_苦酸_旨_甘_旨_塩_酸甘_甘", "U_3"],
  ["－_苦酸_旨_甘_旨_塩_酸甘_酸", "U_3"],
  ["－_苦酸_旨_甘_旨_塩_酸甘_塩", "C_1"],
  ["－_苦酸_旨_甘_旨_塩_苦_苦塩", "B_1"],
  ["－_苦酸_旨_甘_旨_塩_苦_旨", "B_1"],
  ["－_苦酸_旨_甘_旨_塩_苦_甘", "A_2"],
  ["－_苦酸_旨_甘_旨_塩_苦_酸", "B_1"],
  ["－_苦酸_旨_甘_旨_塩_苦_塩", "B_1"],
  ["－_苦酸_旨_甘_旨_塩_酸_苦塩", "B_1"],
  ["－_苦酸_旨_甘_旨_塩_酸_旨", "U_4"],
  ["－_苦酸_旨_甘_旨_塩_酸_甘", "U_3"],
  ["－_苦酸_旨_甘_旨_塩_酸_酸", "U_3"],
  ["－_苦酸_旨_甘_旨_塩_酸_塩", "C_1"],
  ["－_苦酸_旨_甘_旨_塩_甘_苦塩", "A_2"],
  ["－_苦酸_旨_甘_旨_塩_甘_旨", "A_3"],
  ["－_苦酸_旨_甘_旨_塩_甘_甘", "A_3"],
  ["－_苦酸_旨_甘_旨_塩_甘_酸", "U_3"],
  ["－_苦酸_旨_甘_旨_塩_甘_塩", "C_1"],
  ["－_苦酸_旨_甘_旨_甘_旨_苦塩", "A_2"],
  ["－_苦酸_旨_甘_旨_甘_旨_旨", "U_2"],
  ["－_苦酸_旨_甘_旨_甘_旨_甘", "A_4"],
  ["－_苦酸_旨_甘_旨_甘_旨_酸", "U_2"],
  ["－_苦酸_旨_甘_旨_甘_旨_塩", "A_3"],
  ["－_苦酸_旨_甘_旨_甘_酸甘_苦塩", "A_2"],
  ["－_苦酸_旨_甘_旨_甘_酸甘_旨", "U_2"],
  ["－_苦酸_旨_甘_旨_甘_酸甘_甘", "A_1"],
  ["－_苦酸_旨_甘_旨_甘_酸甘_酸", "U_3"],
  ["－_苦酸_旨_甘_旨_甘_酸甘_塩", "U_3"],
  ["－_苦酸_旨_甘_旨_甘_苦_苦塩", "A_2"],
  ["－_苦酸_旨_甘_旨_甘_苦_旨", "A_2"],
  ["－_苦酸_旨_甘_旨_甘_苦_甘", "A_2"],
  ["－_苦酸_旨_甘_旨_甘_苦_酸", "A_2"],
  ["－_苦酸_旨_甘_旨_甘_苦_塩", "A_2"],
  ["－_苦酸_旨_甘_旨_甘_酸_苦塩", "A_2"],
  ["－_苦酸_旨_甘_旨_甘_酸_旨", "U_2"],
  ["－_苦酸_旨_甘_旨_甘_酸_甘", "U_3"],
  ["－_苦酸_旨_甘_旨_甘_酸_酸", "U_3"],
  ["－_苦酸_旨_甘_旨_甘_酸_塩", "U_3"],
  ["－_苦酸_旨_甘_旨_甘_甘_苦塩", "A_2"],
  ["－_苦酸_旨_甘_旨_甘_甘_旨", "A_4"],
  ["－_苦酸_旨_甘_旨_甘_甘_甘", "A_1"],
  ["－_苦酸_旨_甘_旨_甘_甘_酸", "U_3"],
  ["－_苦酸_旨_甘_旨_甘_甘_塩", "A_3"],
  ["－_苦酸_旨_甘_旨_酸_旨_苦塩", "B_1"],
  ["－_苦酸_旨_甘_旨_酸_旨_旨", "U_4"],
  ["－_苦酸_旨_甘_旨_酸_旨_甘", "U_2"],
  ["－_苦酸_旨_甘_旨_酸_旨_酸", "U_4"],
  ["－_苦酸_旨_甘_旨_酸_旨_塩", "U_4"],
  ["－_苦酸_旨_甘_旨_酸_酸甘_苦塩", "U_3"],
  ["－_苦酸_旨_甘_旨_酸_酸甘_旨", "U_2"],
  ["－_苦酸_旨_甘_旨_酸_酸甘_甘", "U_3"],
  ["－_苦酸_旨_甘_旨_酸_酸甘_酸", "U_3"],
  ["－_苦酸_旨_甘_旨_酸_酸甘_塩", "U_3"],
  ["－_苦酸_旨_甘_旨_酸_苦_苦塩", "B_3"],
  ["－_苦酸_旨_甘_旨_酸_苦_旨", "U_4"],
  ["－_苦酸_旨_甘_旨_酸_苦_甘", "A_2"],
  ["－_苦酸_旨_甘_旨_酸_苦_酸", "B_3"],
  ["－_苦酸_旨_甘_旨_酸_苦_塩", "B_1"],
  ["－_苦酸_旨_甘_旨_酸_酸_苦塩", "B_3"],
  ["－_苦酸_旨_甘_旨_酸_酸_旨", "U_4"],
  ["－_苦酸_旨_甘_旨_酸_酸_甘", "U_3"],
  ["－_苦酸_旨_甘_旨_酸_酸_酸", "U_3"],
  ["－_苦酸_旨_甘_旨_酸_酸_塩", "U_3"],
  ["－_苦酸_旨_甘_旨_酸_甘_苦塩", "A_2"],
  ["－_苦酸_旨_甘_旨_酸_甘_旨", "U_2"],
  ["－_苦酸_旨_甘_旨_酸_甘_甘", "U_3"],
  ["－_苦酸_旨_甘_旨_酸_甘_酸", "U_3"],
  ["－_苦酸_旨_甘_旨_酸_甘_塩", "U_3"]
]);